/*
  Fast Friction vehicle database

  Customer selection:
    Make -> Model -> Chassis / generation year -> Engine -> Power

  year:
    Customer-facing model/chassis production range.

  engineYear:
    Exact application period for that engine.

  chassis:
    Explicit chassis code where supplied by the source data.

  engineCodes:
    Stored for future matching/reference. Not shown to the customer.

  productTag:
    Generated automatically from the vehicle record.
*/

(function () {
  var MAKES = {
    F: 'Ford',
    P: 'Peugeot',
    R: 'Alfa Romeo',
    A: 'Audi'
  };

  var STYLES = {
    '': '',
    S: 'Sportback',
    H: 'Hatchback',
    C: 'Convertible',
    L: 'Limousine'
  };

  var FUELS = {
    P: 'Petrol',
    D: 'Diesel',
    PE: 'Petrol/Electric',
    DE: 'Diesel/Electric',
    PC: 'Petrol/CNG',
    PL: 'Petrol/LPG',
    PT: 'Petrol/Ethanol',
    E: 'Electric'
  };

  function tagText(value, keepDot) {
    var text = String(value || '')
      .trim()
      .toUpperCase()
      .replace(/&/g, 'AND');

    var pattern = keepDot
      ? /[^A-Z0-9.]+/g
      : /[^A-Z0-9]+/g;

    return text
      .replace(pattern, '-')
      .replace(/^-+|-+$/g, '');
  }

  function yearTag(value) {
    var matches =
      String(value || '')
        .match(/\d{2}\/\d{2}/g) || [];

    if (matches.length) {
      return matches
        .map(function (part) {
          return part.replace('/', '');
        })
        .join('-');
    }

    return tagText(value, false);
  }

  function makeProductTag(vehicle) {
    var parts = [
      'VF',
      tagText(vehicle.make, false),
      tagText(vehicle.model, false)
    ];

    if (vehicle.chassis) {
      parts.push(
        tagText(vehicle.chassis, false)
      );
    }

    parts.push(
      tagText(vehicle.engine, true)
    );

    parts.push(
      tagText(vehicle.power, false)
    );

    parts.push(
      yearTag(
        vehicle.engineYear ||
        vehicle.year
      )
    );

    return parts
      .filter(Boolean)
      .join('-');
  }

  var DATA = `
F|Puma|||1.0 EcoBoost Petrol|95/70|09/19 -|999|P|09/19 -|
F|Puma|||1.0 EcoBoost Petrol|125/92|09/19 -|999|P|09/19 -|
F|Puma|||1.0 EcoBoost mHEV Petrol/Electric|125/92|09/19 -|999|PE|09/19 -|
F|Puma|||1.0 EcoBoost mHEV Petrol/Electric|155/114|09/19 -|999|PE|09/19 -|
F|Puma|||1.0 EcoBoost mHEV Petrol/Electric|160/118|09/19 -|999|PE|03/23 -|
F|Puma|||1.0 Flexifuel Petrol/Ethanol|125/92|09/19 -|999|PT|12/21 -|
F|Puma|||1.0 ST EcoBoost mHEV Petrol/Electric|170/125|09/19 -|999|PE|03/23 -|
F|Puma|||1.5 EcoBlue Diesel|120/88|09/19 -|1498|D|04/20 -|
F|Puma|||1.5 ST EcoBoost Petrol|200/147|09/19 -|1498|P|11/20 -|
F|Puma|||GEN-E Electric|169/124|09/19 -||E|01/25 -|
P|3008|||1.2 Hybrid Petrol/Electric|136/100|05/16 -|1199|PE|05/23 - 11/23|
P|3008|||1.2 THP / PureTech Petrol|131/96|05/16 -|1199|P|05/16 -|
P|3008|||1.5 BlueHDi Diesel|131/96|05/16 -|1498|D|02/18 -|
P|3008|||1.6 BlueHDi Diesel|100/73|05/16 -|1598|D|11/16 - 12/19|
P|3008|||1.6 BlueHDi Diesel|116/85|05/16 -|1598|D|11/16 - 12/19|
P|3008|||1.6 BlueHDi Diesel|120/88|05/16 -|1598|D|05/16 - 12/19|
P|3008|||1.6 PureTech Petrol|181/133|05/16 -|1598|P|07/18 -|
P|3008|||1.6 THP Petrol|150/110|05/16 -|1598|P|11/17 -|
P|3008|||1.6 THP Petrol|165/121|05/16 -|1598|P|05/16 -|
P|3008|||2.0 BlueHDi Diesel|136/100|05/16 -|1998|D|11/16 -|
P|3008|||2.0 BlueHDi Diesel|150/110|05/16 -|1998|D|05/16 - 09/20|
P|3008|||2.0 BlueHDi Diesel|177/130|05/16 -|1998|D|01/18 -|
P|3008|||2.0 BlueHDi Diesel|181/133|05/16 -|1998|D|05/16 -|
P|3008|||1.6 Hybrid Petrol/Electric|224/165|05/16 -|1598|PE|10/19 -|
P|3008|||1.6 Hybrid 180 Petrol/Electric|179/132|05/16 -|1598|PE|11/22 -|
P|3008|||1.6 Hybrid4 Petrol/Electric|299/220|05/16 -|1598|PE|10/19 -|
R|159|||1.8 MPI Petrol|140/103|06/05 - 12/12|1742|P|06/05 - 11/11|
R|159|||1.8 TBi Petrol|200/147|06/05 - 12/12|1742|P|05/09 - 12/12|
R|159|||1.9 JTDM 8V Diesel|120/88|06/05 - 12/12|1910|D|09/05 - 11/11|
R|159|||1.9 JTDM 16V Diesel|150/110|06/05 - 12/12|1910|D|09/05 - 11/11|
R|159|||1.9 JTDM 16V Diesel|136/100|06/05 - 12/12|1910|D|09/05 - 11/11|
R|159|||1.9 JTS Petrol|160/118|06/05 - 12/12|1910|P|09/05 - 11/11|
R|159|||2.0 JTDM Diesel|170/125|06/05 - 12/12|1998|D|05/09 - 11/11|
R|159|||2.0 JTDM Diesel|136/100|06/05 - 12/12|1998|D|06/10 - 11/11|
R|159|||2.2 JTS Petrol|185/136|06/05 - 12/12|2198|P|09/05 - 11/11|
R|159|||2.4 JTDM Diesel|200/147|06/05 - 12/12|2387|D|09/05 - 11/11|
R|159|||2.4 JTDM Diesel|210/154|06/05 - 12/12|2387|D|07/07 - 11/11|
R|159|||2.4 JTDM Q4 Diesel|210/154|06/05 - 12/12|2387|D|05/07 - 11/11|
R|159|||3.2 JTS Petrol|260/191|06/05 - 12/12|3195|P|01/08 - 11/11|
R|159|||3.2 JTS Q4 Petrol|260/191|06/05 - 12/12|3195|P|12/05 - 11/11|
R|Giulietta|||1.4 BiFuel Petrol/LPG|120/88|04/10 - 12/20|1368|PL|12/11 - 02/17|
R|Giulietta|||1.4 TB Petrol|150/110|04/10 - 12/20|1368|P|09/14 - 10/18|
R|Giulietta|||1.4 TB Petrol|120/88|04/10 - 12/20|1368|P|04/10 - 12/20|
R|Giulietta|||1.4 TB Petrol|170/125|04/10 - 12/20|1368|P|04/10 - 10/18|
R|Giulietta|||1.4 TB Petrol|116/85|04/10 - 12/20|1368|P|04/10 - 02/16|
R|Giulietta|||1.4 TB Petrol|163/120|04/10 - 12/20|1368|P|04/10 - 10/18|
R|Giulietta|||1.4 TB Petrol|105/77|04/10 - 12/20|1368|P|04/11 - 02/17|
R|Giulietta|||1.6 JTDM Diesel|105/77|04/10 - 12/20|1598|D|04/10 - 02/16|
R|Giulietta|||1.6 JTDM Diesel|120/88|04/10 - 12/20|1598|D|02/15 - 12/20|
R|Giulietta|||1.6 JTDM Diesel|116/85|04/10 - 12/20|1598|D|09/15 - 10/18|
R|Giulietta|||1.8 TBi Petrol|230/169|04/10 - 12/20|1742|P|04/10 - 09/13|
R|Giulietta|||1.8 TBi Petrol|235/173|04/10 - 12/20|1742|P|04/10 - 02/16|
R|Giulietta|||1.8 TBi Petrol|241/177|04/10 - 12/20|1742|P|09/13 - 10/18|
R|Giulietta|||2.0 JTDM Diesel|140/103|04/10 - 12/20|1998|D|04/10 - 12/20|
R|Giulietta|||2.0 JTDM Diesel|170/125|04/10 - 12/20|1998|D|04/10 - 12/20|
R|Giulietta|||2.0 JTDM Diesel|163/120|04/10 - 12/20|1998|D|04/10 - 10/18|
R|Giulietta|||2.0 JTDM Diesel|136/100|04/10 - 12/20|1998|D|04/10 - 02/16|
R|Giulietta|||2.0 JTDM Diesel|150/110|04/10 - 12/20|1998|D|08/13 - 10/18|
R|Giulietta|||2.0 JTDM Diesel|175/129|04/10 - 12/20|1998|D|11/13 - 10/18|
R|Giulia|||2.0 Petrol|200/147|10/15 -|1995|P|08/16 - 10/22|
R|Giulia|||2.0 Petrol|280/206|10/15 -|1995|P|08/16 -|
R|Giulia|||2.0 Q4 Petrol|280/206|10/15 -|1995|P|08/16 -|
R|Giulia|||2.0 Q4 Petrol|350/257|10/15 -|1995|P|08/17 -|
R|Giulia|||2.2 D Diesel|150/110|10/15 -|2143|D|10/15 -|
R|Giulia|||2.2 D Diesel|160/118|10/15 -|2143|D|08/18 -|
R|Giulia|||2.2 D Diesel|180/132|10/15 -|2143|D|10/15 -|
R|Giulia|||2.2 D Diesel|136/100|10/15 -|2143|D|10/15 -|
R|Giulia|||2.2 D Diesel|190/140|10/15 -|2143|D|08/18 - 10/22|
R|Giulia|||2.2 D Q4 Diesel|190/140|10/15 -|2143|D|08/18 - 10/22|
R|Giulia|||2.2 D Q4 Diesel|180/132|10/15 -|2143|D|04/17 -|
R|Giulia|||2.2 D Q4 Diesel|209/154|10/15 -|2143|D|11/16 -|
R|Giulia|||2.9 Petrol|519/382|10/15 -|2891|P|11/19 -|
R|Giulia|||2.9 Quadrifoglio Petrol|521/383|10/15 -|2891|P|04/24 -|
R|Giulia|||2.9 Quadrifoglio Petrol|510/375|10/15 -|2891|P|10/15 -|
R|Brera|||1.8 TBi Petrol|200/147|01/06 - 05/11|1742|P|05/09 - 06/10|
R|Brera|||2.0 JTDM Diesel|170/125|01/06 - 05/11|1956|D|05/09 - 06/10|
R|Brera|||2.0 JTDM Diesel|163/120|01/06 - 05/11|1956|D|03/08 - 06/10|
R|Brera|||2.2 JTS Petrol|185/136|01/06 - 05/11|2198|P|01/06 - 05/11|
R|Brera|||2.4 JTDM 20V Diesel|200/147|01/06 - 05/11|2387|D|01/06 - 03/11|
R|Brera|||2.4 JTDM 20V Diesel|210/154|01/06 - 05/11|2387|D|05/07 - 03/11|
R|Brera|||3.2 JTS Petrol|260/191|01/06 - 05/11|3195|P|03/08 - 06/10|
R|Brera|||3.2 JTS Q4 Petrol|260/191|01/06 - 05/11|3195|P|01/06 - 05/11|
R|MiTo|||0.9 TwinAir Petrol|86/63|08/08 - 10/18|875|P|07/11 - 12/13|
R|MiTo|||0.9 TwinAir Petrol|101/74|08/08 - 10/18|875|P|12/13 - 08/18|
R|MiTo|||0.9 TwinAir Petrol|105/77|08/08 - 10/18|875|P|04/13 - 08/18|
R|MiTo|||1.3 Multijet Diesel|90/66|08/08 - 10/18|1248|D|08/08 - 08/10|
R|MiTo|||1.3 Multijet Diesel|95/70|08/08 - 10/18|1248|D|09/09 - 10/18|
R|MiTo|||1.3 Multijet Diesel|80/59|08/08 - 10/18|1248|D|12/13 - 12/15|
R|MiTo|||1.3 Multijet Diesel|84/62|08/08 - 10/18|1248|D|01/11 - 12/15|
R|MiTo|||1.4 Petrol|78/57|08/08 - 10/18|1368|P|03/11 - 10/18|
R|MiTo|||1.4 Petrol|95/70|08/08 - 10/18|1368|P|09/08 - 08/13|
R|MiTo|||1.4 Petrol|78/58|08/08 - 10/18|1368|P|08/08 - 08/13|
R|MiTo|||1.4 Petrol|69/51|08/08 - 10/18|1368|P|05/11 - 10/18|
R|MiTo|||1.4 Bifuel Petrol/CNG|120/88|08/08 - 10/18|1368|PC|04/16 - 10/18|
R|MiTo|||1.4 Bifuel Petrol/LPG|120/88|08/08 - 10/18|1368|PL|01/09 - 08/16|
R|MiTo|||1.4 MultiAir Petrol|105/77|08/08 - 10/18|1368|P|09/09 - 08/13|
R|MiTo|||1.4 MultiAir Petrol|170/125|08/08 - 10/18|1368|P|09/09 - 10/18|
R|MiTo|||1.4 TB Petrol|140/103|08/08 - 10/18|1368|P|12/13 - 10/18|
R|MiTo|||1.4 TJet Petrol|155/114|08/08 - 10/18|1368|P|08/08 - 06/11|
R|MiTo|||1.4 TJet Petrol|150/110|08/08 - 10/18|1368|P|09/08 - 06/11|
R|MiTo|||1.4 TJet Petrol|120/88|08/08 - 10/18|1368|P|08/08 - 08/13|
R|MiTo|||1.4 Turbo MultiAir Petrol|135/99|08/08 - 10/18|1368|P|10/09 - 12/14|
R|MiTo|||1.4 Turbo MultiAir Petrol|163/120|08/08 - 10/18|1368|P|10/09 - 10/18|
R|MiTo|||1.6 JTDM Diesel|120/88|08/08 - 10/18|1598|D|08/08 - 08/15|
R|MiTo|||1.6 JTDM Diesel|115/85|08/08 - 10/18|1598|D|08/08 - 08/15|
R|Spider|||1.8 TBi Petrol|200/147|03/06 - 03/11|1742|P|05/09 - 03/11|
R|Spider|||2.0 JTDM Diesel|170/125|03/06 - 03/11|1956|D|05/09 - 06/10|
R|Spider|||2.0 JTDM Diesel|163/120|03/06 - 03/11|1956|D|04/09 - 03/11|
R|Spider|||2.2 JTS Petrol|185/136|03/06 - 03/11|2198|P|03/06 - 03/11|
R|Spider|||2.4 JTDM Diesel|210/154|03/06 - 03/11|2387|D|03/08 - 03/11|
R|Spider|||2.4 JTDM Diesel|200/147|03/06 - 03/11|2387|D|03/06 - 03/11|
R|Spider|||3.2 JTS Petrol|260/191|03/06 - 03/11|3195|P|03/08 - 03/11|
R|Spider|||3.2 JTS Q4 Petrol|260/191|03/06 - 03/11|3195|P|03/06 - 03/11|
R|Stelvio|||2.0 Petrol|280/206|12/16 -|1995|P|12/16 -|
R|Stelvio|||2.0 Q4 Petrol|280/206|12/16 -|1995|P|12/16 -|
R|Stelvio|||2.0 Q4 Petrol|201/148|12/16 -|1995|P|12/16 -|
R|Stelvio|||2.0 Q4 Petrol|250/184|12/16 -|1995|P|12/19 -|
R|Stelvio|||2.2 D Diesel|180/132|12/16 -|2143|D|12/16 -|
R|Stelvio|||2.2 D Diesel|190/140|12/16 -|2143|D|08/18 - 12/22|
R|Stelvio|||2.2 D Diesel|160/118|12/16 -|2143|D|08/18 -|
R|Stelvio|||2.2 D Diesel|150/110|12/16 -|2143|D|12/16 -|
R|Stelvio|||2.2 D Q4 Diesel|180/132|12/16 -|2143|D|12/16 -|
R|Stelvio|||2.2 D Q4 Diesel|190/140|12/16 -|2143|D|08/18 - 12/22|
R|Stelvio|||2.2 D Q4 Diesel|209/154|12/16 -|2143|D|12/16 -|
R|Stelvio|||2.9 Q4 Petrol|520/382|12/16 -|2891|P|12/16 -|
R|Stelvio|||2.9 Q4 Petrol|510/375|12/16 -|2891|P|12/16 -|
R|Tonale|||1.3 Plug-in Hybrid Q4 Petrol/Electric|280/206|03/22 -|1332|PE|10/22 -|
R|Tonale|||1.5 Mild Hybrid Petrol/Electric|130/96|03/22 -|1469|PE|03/22 -|
R|Tonale|||1.5 Mild Hybrid Petrol/Electric|160/118|03/22 -|1469|PE|03/22 -|
R|Tonale|||1.6 VGT-D Diesel|130/96|03/22 -|1598|D|03/22 -|
A|A1 Allstreet|||25 TFSI Petrol|95/70|07/22 -|999|P|07/22 -|
A|A1 Allstreet|||30 TFSI Petrol|110/81|07/22 -|999|P|07/22 -|
A|A1 Allstreet|||35 TFSI Petrol|150/110|07/22 -|1498|P|07/22 -|
A|A1 Allstreet|||40 TFSI Petrol|207/152|07/22 -|1984|P|07/22 -|
A|A1 City Carver|||25 TFSI Petrol|95/70|07/19 - 06/22|999|P|07/19 - 06/22|
A|A1 City Carver|||30 TFSI Petrol|110/81|07/19 - 06/22|999|P|07/19 - 06/22|
A|A1 City Carver|||30 TFSI Petrol|116/85|07/19 - 06/22|999|P|07/19 - 06/22|
A|A1 City Carver|||35 TFSI Petrol|150/110|07/19 - 06/22|1498|P|07/19 - 06/22|
A|A1 City Carver|||40 TFSI Petrol|200/147|07/19 - 06/22|1984|P|07/19 - 06/22|
A|A1|H|8X1 / 8XK|1.0 TFSI Petrol|82/60|05/10 - 10/18|999|P|03/15 - 10/18|
A|A1|H|8X1 / 8XK|1.0 TFSI Petrol|95/70|05/10 - 10/18|999|P|03/15 - 10/18|
A|A1|H|8X1 / 8XK|1.2 TFSI Petrol|86/63|05/10 - 10/18|1197|P|05/10 - 04/15|
A|A1|H|8X1 / 8XK|1.4 TFSI Petrol|122/90|05/10 - 10/18|1390|P|05/10 - 04/15|
A|A1|H|8X1 / 8XK|1.4 TFSI Petrol|125/92|05/10 - 10/18|1395|P|11/14 - 10/18|
A|A1|H|8X1 / 8XK|1.4 TFSI Petrol|140/103|05/10 - 10/18|1395|P|04/12 - 04/15|
A|A1|H|8X1 / 8XK|1.4 TFSI Petrol|150/110|05/10 - 10/18|1395|P|11/14 - 10/18|
A|A1|H|8X1 / 8XK|1.4 TFSI Petrol|185/136|05/10 - 10/18|1390|P|01/11 - 04/15|
A|A1|H|8X1 / 8XK|1.6 TDI Diesel|90/66|05/10 - 10/18|1598|D|03/11 - 04/15|
A|A1|H|8X1 / 8XK|1.6 TDI Diesel|105/77|05/10 - 10/18|1598|D|05/10 - 04/15|
A|A1|H|8X1 / 8XK|1.6 TDI Diesel|116/85|05/10 - 10/18|1598|D|11/14 - 10/18|
A|A1|H|8X1 / 8XK|1.6 TDI Diesel|110/81|05/10 - 10/18|1598|D|11/14 - 10/18|
A|A1|H|8X1 / 8XK|2.0 TDI Diesel|136/100|05/10 - 10/18|1968|D|09/11 - 04/15|
A|A1|H|8X1 / 8XK|2.0 TDI Diesel|143/105|05/10 - 10/18|1968|D|09/11 - 04/15|
A|A1|H|8X1 / 8XK|2.0 TFSI Petrol|256/188|05/10 - 10/18|1984|P|03/12 - 11/12|
A|S1|H|8X1 / 8XK|2.0 TFSI quattro Petrol|231/170|05/10 - 10/18|1984|P|03/14 - 10/18|
A|A1 Sportback|S|8XA / 8XF|1.0 TFSI Petrol|82/60|11/11 - 10/18|999|P|03/15 - 10/18|
A|A1 Sportback|S|8XA / 8XF|1.0 TFSI Petrol|95/70|11/11 - 10/18|999|P|03/15 - 10/18|
A|A1 Sportback|S|8XA / 8XF|1.2 TFSI Petrol|86/63|11/11 - 10/18|1197|P|11/11 - 04/15|
A|A1 Sportback|S|8XA / 8XF|1.4 TDI Diesel|90/66|11/11 - 10/18|1422|D|11/14 - 10/18|
A|A1 Sportback|S|8XA / 8XF|1.4 TFSI Petrol|122/90|11/11 - 10/18|1390|P|11/11 - 04/15|
A|A1 Sportback|S|8XA / 8XF|1.4 TFSI Petrol|125/92|11/11 - 10/18|1395|P|11/14 - 10/18|
A|A1 Sportback|S|8XA / 8XF|1.4 TFSI Petrol|140/103|11/11 - 10/18|1395|P|04/12 - 04/15|
A|A1 Sportback|S|8XA / 8XF|1.4 TFSI Petrol|150/110|11/11 - 10/18|1395|P|11/14 - 10/18|
A|A1 Sportback|S|8XA / 8XF|1.4 TFSI Petrol|185/136|11/11 - 10/18|1390|P|11/11 - 04/15|
A|A1 Sportback|S|8XA / 8XF|1.6 TDI Diesel|90/66|11/11 - 10/18|1598|D|11/11 - 04/15|
A|A1 Sportback|S|8XA / 8XF|1.6 TDI Diesel|105/77|11/11 - 10/18|1598|D|11/11 - 04/15|
A|A1 Sportback|S|8XA / 8XF|1.6 TDI Diesel|110/81|11/11 - 10/18|1598|D|11/14 - 10/18|
A|A1 Sportback|S|8XA / 8XF|1.6 TDI Diesel|116/85|11/11 - 10/18|1598|D|11/14 - 10/18|
A|A1 Sportback|S|8XA / 8XF|1.8 TFSI Petrol|192/141|11/11 - 10/18|1798|P|02/15 - 10/18|
A|A1 Sportback|S|8XA / 8XF|2.0 TDI Diesel|136/100|11/11 - 10/18|1968|D|09/11 - 04/15|
A|A1 Sportback|S|8XA / 8XF|2.0 TDI Diesel|143/105|11/11 - 10/18|1968|D|09/11 - 04/15|
A|A1 Sportback|S|8XA / 8XF|2.0 TFSI Petrol|256/188|11/11 - 10/18|1984|P|03/12 - 11/12|
A|S1 Sportback|S|8XA / 8XF|2.0 TFSI quattro Petrol|231/170|11/11 - 10/18|1984|P|03/14 - 10/18|
A|A1 Sportback|S|GBA|25 TFSI Petrol|95/70|07/18 -|999|P|07/18 -|
A|A1 Sportback|S|GBA|30 TFSI Petrol|110/81|07/18 -|999|P|07/18 -|
A|A1 Sportback|S|GBA|30 TFSI Petrol|116/85|07/18 -|999|P|07/18 -|
A|A1 Sportback|S|GBA|35 TFSI Petrol|150/110|07/18 -|1498|P|07/18 -|
A|A1 Sportback|S|GBA|40 TFSI Petrol|200/147|07/18 -|1984|P|07/18 -|
A|A1 Sportback|S|GBA|40 TFSI Petrol|207/152|07/18 -|1984|P|07/18 -|
A|A2|||1.2 TDI Diesel|61/45|02/00 - 08/05|1191|D|02/00 - 08/05|
A|A2|||1.4 Petrol|75/55|02/00 - 08/05|1390|P|02/00 - 08/05|
A|A2|||1.4 TDI Diesel|75/55|02/00 - 08/05|1422|D|02/00 - 08/05|
A|A2|||1.4 TDI Diesel|90/66|02/00 - 08/05|1422|D|02/00 - 08/05|
A|A2|||1.6 FSI Petrol|110/81|02/00 - 08/05|1598|P|02/00 - 08/05|
A|A3|H|8L1|1.6 Petrol (1.6L)|101/74|09/96 - 12/04|1595|P|09/96 - 12/04|
A|A3|H|8L1|1.8 Petrol|125/92|09/96 - 12/04|1781|P|09/96 - 05/03|
A|A3|H|8L1|1.8 T Petrol|150/110|09/96 - 12/04|1781|P|12/96 - 05/03|
A|A3|H|8L1|1.8 T Petrol|180/132|09/96 - 12/04|1781|P|12/98 - 05/03|
A|A3|H|8L1|1.8 T quattro Petrol|150/110|09/96 - 12/04|1781|P|12/96 - 05/03|
A|A3|H|8L1|1.8 T quattro Petrol|180/132|09/96 - 12/04|1781|P|10/98 - 05/03|
A|A3|H|8L1|1.9 TDI Diesel|90/66|09/96 - 12/04|1896|D|09/96 - 07/01|
A|A3|H|8L1|1.9 TDI Diesel|100/74|09/96 - 12/04|1896|D|10/00 - 05/03|
A|A3|H|8L1|1.9 TDI Diesel|110/81|09/96 - 12/04|1896|D|08/97 - 07/01|
A|A3|H|8L1|1.9 TDI Diesel|130/96|09/96 - 12/04|1896|D|08/00 - 05/03|
A|A3|H|8L1|1.9 TDI quattro Diesel|130/96|09/96 - 12/04|1896|D|08/00 - 05/03|
A|S3|H|8L1|1.8 T quattro Petrol|210/154|09/96 - 12/04|1781|P|03/99 - 04/02|
A|S3|H|8L1|1.8 T quattro Petrol|224/165|09/96 - 12/04|1781|P|10/01 - 05/03|
A|A3|H|8P1|1.2 TSI Petrol|105/77|05/03 - 08/12|1197|P|04/10 - 08/12|
A|A3|H|8P1|1.4 TFSI Petrol|125/92|05/03 - 08/12|1390|P|09/07 - 08/12|
A|A3|H|8P1|1.6 Petrol|102/75|05/03 - 08/12|1595|P|05/03 - 08/12|
A|A3|H|8P1|1.6 FSI Petrol|115/85|05/03 - 08/12|1598|P|08/03 - 09/07|
A|A3|H|8P1|1.6 TDI Diesel|90/66|05/03 - 08/12|1598|D|05/09 - 08/12|
A|A3|H|8P1|1.6 TDI Diesel|105/77|05/03 - 08/12|1598|D|05/09 - 08/12|
A|A3|H|8P1|1.8 TFSI Petrol|160/118|05/03 - 08/12|1798|P|11/06 - 08/12|
A|A3|H|8P1|1.8 TFSI quattro Petrol|160/118|05/03 - 08/12|1798|P|07/08 - 08/12|
A|A3|H|8P1|1.9 TDI Diesel|105/77|05/03 - 08/12|1896|D|05/03 - 05/10|
A|A3|H|8P1|2.0 FSI Petrol|150/110|05/03 - 08/12|1984|P|05/03 - 06/08|
A|A3|H|8P1|2.0 TDI Diesel|136/100|05/03 - 08/12|1968|D|05/03 - 08/12|
A|A3|H|8P1|2.0 TDI Diesel|140/103|05/03 - 08/12|1968|D|06/05 - 06/08|
A|A3|H|8P1|2.0 TDI Diesel|163/120|05/03 - 08/12|1968|D|06/06 - 06/08|
A|A3|H|8P1|2.0 TDI Diesel|170/125|05/03 - 08/12|1968|D|03/06 - 08/12|
A|A3|H|8P1|2.0 TDI 16V Diesel|140/103|05/03 - 08/12|1968|D|05/03 - 08/12|
A|A3|H|8P1|2.0 TDI 16V quattro Diesel|140/103|05/03 - 08/12|1968|D|11/05 - 08/12|
A|A3|H|8P1|2.0 TDI quattro Diesel|140/103|05/03 - 08/12|1968|D|01/06 - 06/08|
A|A3|H|8P1|2.0 TDI quattro Diesel|170/125|05/03 - 08/12|1968|D|03/06 - 08/12|
A|A3|H|8P1|2.0 TFSI Petrol|200/147|05/03 - 08/12|1984|P|09/04 - 08/12|
A|A3|H|8P1|2.0 TFSI quattro Petrol|200/147|05/03 - 08/12|1984|P|09/04 - 08/12|
A|A3|H|8P1|3.2 V6 quattro Petrol|250/184|05/03 - 08/12|3189|P|05/03 - 05/09|
A|S3|H|8P1|2.0 TFSI quattro Petrol|256/188|05/03 - 08/12|1984|P|07/08 - 08/12|
A|S3|H|8P1|2.0 TFSI quattro Petrol|265/195|05/03 - 08/12|1984|P|06/08 - 08/12|
A|A3|H|8V1 / 8VK|1.0 TFSI Petrol|115/85|04/12 - 10/20|999|P|07/16 - 10/20|
A|A3|H|8V1 / 8VK|1.2 TFSI Petrol|105/77|04/12 - 10/20|1197|P|05/13 - 05/15|
A|A3|H|8V1 / 8VK|1.2 TFSI Petrol|110/81|04/12 - 10/20|1197|P|05/14 - 08/16|
A|A3|H|8V1 / 8VK|1.4 TFSI Petrol|122/90|04/12 - 10/20|1395|P|09/12 - 10/20|
A|A3|H|8V1 / 8VK|1.4 TFSI Petrol|125/92|04/12 - 10/20|1395|P|05/14 - 08/16|
A|A3|H|8V1 / 8VK|1.4 TFSI Petrol|140/103|04/12 - 10/20|1395|P|03/13 - 11/14|
A|A3|H|8V1 / 8VK|1.4 TSI Petrol|150/110|04/12 - 10/20|1395|P|05/14 - 10/20|
A|A3|H|8V1 / 8VK|1.5 TFSI Petrol|150/110|04/12 - 10/20|1498|P|05/17 - 10/18|
A|A3|H|8V1 / 8VK|1.6 TDI Diesel|105/77|04/12 - 10/20|1598|D|10/12 - 12/16|
A|A3|H|8V1 / 8VK|1.6 TDI Diesel|110/81|04/12 - 10/20|1598|D|09/13 - 10/20|
A|A3|H|8V1 / 8VK|1.6 TDI Diesel|115/85|04/12 - 10/20|1598|D|02/17 - 10/20|
A|A3|H|8V1 / 8VK|1.6 TDI quattro Diesel|110/81|04/12 - 10/20|1598|D|05/15 - 08/16|
A|A3|H|8V1 / 8VK|1.8 40 TFSI Petrol|180/132|04/12 - 10/20|1798|P|03/14 - 12/15|
A|A3|H|8V1 / 8VK|1.8 TFSI Petrol|180/132|04/12 - 10/20|1798|P|09/12 - 08/16|
A|A3|H|8V1 / 8VK|1.8 TFSI quattro Petrol|180/132|04/12 - 10/20|1798|P|05/13 - 08/16|
A|A3|H|8V1 / 8VK|2.0 45 TFSI Petrol|220/162|04/12 - 10/20|1984|P|02/15 - 08/16|
A|A3|H|8V1 / 8VK|2.0 TDI Diesel|110/81|04/12 - 10/20|1968|D|05/13 - 10/20|
A|A3|H|8V1 / 8VK|2.0 TDI Diesel|136/100|04/12 - 10/20|1968|D|05/13 - 08/16|
A|A3|H|8V1 / 8VK|2.0 TDI Diesel|143/105|04/12 - 10/20|1968|D|03/13 - 10/20|
A|A3|H|8V1 / 8VK|2.0 TDI Diesel|150/110|04/12 - 10/20|1968|D|09/12 - 10/20|
A|A3|H|8V1 / 8VK|2.0 TDI Diesel|184/135|04/12 - 10/20|1968|D|05/13 - 07/18|
A|A3|H|8V1 / 8VK|2.0 TDI quattro Diesel|150/110|04/12 - 10/20|1968|D|02/13 - 10/20|
A|A3|H|8V1 / 8VK|2.0 TDI quattro Diesel|184/135|04/12 - 10/20|1968|D|05/13 - 07/18|
A|A3|H|8V1 / 8VK|2.0 TFSI Petrol|190/140|04/12 - 10/20|1984|P|05/16 - 10/20|
A|A3|H|8V1 / 8VK|2.0 TFSI quattro Petrol|190/140|04/12 - 10/20|1984|P|05/16 - 10/20|
A|A3|H|8V1 / 8VK|30 TDI Diesel|115/85|04/12 - 10/20|1598|D|07/18 - 10/20|
A|A3|H|8V1 / 8VK|30 TFSI Petrol|116/85|04/12 - 10/20|999|P|07/18 - 10/20|
A|A3|H|8V1 / 8VK|35 TDI Diesel|150/110|04/12 - 10/20|1968|D|07/18 - 10/20|
A|A3|H|8V1 / 8VK|35 TFSI Petrol|150/110|04/12 - 10/20|1498|P|10/18 - 10/20|
A|A3|H|8V1 / 8VK|40 TDI quattro Diesel|184/135|04/12 - 10/20|1968|D|07/18 - 10/20|
A|A3|H|8V1 / 8VK|40 TFSI Petrol|190/140|04/12 - 10/20|1984|P|07/18 - 10/20|
A|A3|H|8V1 / 8VK|40 TFSI quattro Petrol|190/140|04/12 - 10/20|1984|P|07/18 - 10/20|
A|S3|H|8V1 / 8VK|2.0 TFSI quattro Petrol|280/206|04/12 - 10/20|1984|P|05/13 - 08/16|
A|S3|H|8V1 / 8VK|2.0 TFSI quattro Petrol|286/210|04/12 - 10/20|1984|P|05/14 - 08/16|
A|S3|H|8V1 / 8VK|2.0 TFSI quattro Petrol|290/213|04/12 - 10/20|1984|P|07/16 - 10/20|
A|S3|H|8V1 / 8VK|2.0 TFSI quattro Petrol|300/221|04/12 - 10/20|1984|P|11/12 - 10/20|
A|S3|H|8V1 / 8VK|2.0 TFSI quattro Petrol|310/228|04/12 - 10/20|1984|P|06/16 - 10/20|
A|A3 Allstreet||8YJ|35 TDI Diesel|150/110|02/24 -|1968|D|02/24 -|
A|A3 Allstreet||8YJ|35 TFSI Mild Hybrid Petrol/Electric|150/110|02/24 -|1498|PE|02/24 -|
A|A3 Allstreet||8YJ|40 TFSI Mild Hybrid quattro Petrol/Electric|204/150|02/24 -|1984|PE|02/24 -|
A|A3 Convertible|C|8P7|1.2 TSI Petrol|105/77|04/08 - 05/13|1197|P|03/10 - 05/13|
A|A3 Convertible|C|8P7|1.4 TFSI Petrol|125/92|04/08 - 05/13|1390|P|02/11 - 05/13|
A|A3 Convertible|C|8P7|1.6 TDI Diesel|105/77|04/08 - 05/13|1598|D|05/09 - 05/13|
A|A3 Convertible|C|8P7|1.8 TFSI Petrol|160/118|04/08 - 05/13|1798|P|04/08 - 05/13|
A|A3 Convertible|C|8P7|2.0 TDI Diesel|140/103|04/08 - 05/13|1968|D|04/08 - 05/13|
A|A3 Convertible|C|8P7|2.0 TDI Diesel|170/125|04/08 - 05/13|1968|D|04/08 - 05/13|
A|A3 Convertible|C|8P7|2.0 TFSI Petrol|200/147|04/08 - 05/13|1984|P|04/08 - 05/13|
A|A3 Convertible|C|8V7 / 8VE|1.4 TFSI Petrol|125/92|10/13 - 10/20|1395|P|02/14 - 08/16|
A|A3 Convertible|C|8V7 / 8VE|1.4 TFSI Petrol|150/110|10/13 - 10/20|1395|P|05/14 - 08/16|
A|A3 Convertible|C|8V7 / 8VE|1.5 TFSI Petrol|150/110|10/13 - 10/20|1498|P|05/17 - 10/20|
A|A3 Convertible|C|8V7 / 8VE|1.6 TDI Diesel|110/81|10/13 - 10/20|1598|D|02/14 - 08/16|
A|A3 Convertible|C|8V7 / 8VE|1.6 TDI Diesel|115/85|10/13 - 10/20|1598|D|02/17 - 10/20|
A|A3 Convertible|C|8V7 / 8VE|1.8 TFSI Petrol|180/132|10/13 - 10/20|1798|P|10/13 - 08/16|
A|A3 Convertible|C|8V7 / 8VE|2.0 TDI Diesel|150/110|10/13 - 10/20|1968|D|10/13 - 10/20|
A|A3 Convertible|C|8V7 / 8VE|2.0 TDI Diesel|184/135|10/13 - 10/20|1968|D|10/13 - 07/18|
A|A3 Convertible|C|8V7 / 8VE|2.0 TFSI Petrol|190/140|10/13 - 10/20|1984|P|05/16 - 10/20|
A|A3 Convertible|C|8V7 / 8VE|30 TDI Diesel|115/85|10/13 - 10/20|1598|D|07/18 - 10/20|
A|A3 Convertible|C|8V7 / 8VE|35 TDI Diesel|150/110|10/13 - 10/20|1968|D|07/18 - 10/20|
A|A3 Convertible|C|8V7 / 8VE|35 TFSI Petrol|150/110|10/13 - 10/20|1498|P|10/18 - 10/20|
A|A3 Convertible|C|8V7 / 8VE|40 TFSI Petrol|190/140|10/13 - 10/20|1984|P|07/18 - 10/20|
A|S3 Convertible|C|8V7 / 8VE|2.0 TFSI quattro Petrol|300/221|10/13 - 10/20|1984|P|10/13 - 08/16|
A|S3 Convertible|C|8V7 / 8VE|2.0 TFSI quattro Petrol|310/228|10/13 - 10/20|1984|P|06/16 - 10/20|
A|A3 Limousine|L|8VS / 8VM|1.0 TFSI Petrol|115/85|05/13 - 10/20|999|P|07/16 - 10/20|
A|A3 Limousine|L|8VS / 8VM|1.2 TFSI Petrol|105/77|05/13 - 10/20|1197|P|05/13 - 05/15|
A|A3 Limousine|L|8VS / 8VM|1.2 TFSI Petrol|110/81|05/13 - 10/20|1197|P|05/14 - 08/16|
A|A3 Limousine|L|8VS / 8VM|1.4 TFSI Petrol|122/90|05/13 - 10/20|1395|P|05/13 - 10/20|
A|A3 Limousine|L|8VS / 8VM|1.4 TFSI Petrol|125/92|05/13 - 10/20|1395|P|05/14 - 08/16|
A|A3 Limousine|L|8VS / 8VM|1.4 TFSI Petrol|140/103|05/13 - 10/20|1395|P|05/13 - 11/14|
A|A3 Limousine|L|8VS / 8VM|1.4 TSI Petrol|150/110|05/13 - 10/20|1395|P|05/14 - 10/20|
A|A3 Limousine|L|8VS / 8VM|1.5 TFSI Petrol|150/110|05/13 - 10/20|1498|P|05/17 - 10/18|
A|A3 Limousine|L|8VS / 8VM|1.6 TDI Diesel|105/77|05/13 - 10/20|1598|D|05/13 - 12/16|
A|A3 Limousine|L|8VS / 8VM|1.6 TDI Diesel|110/81|05/13 - 10/20|1598|D|09/13 - 10/20|
A|A3 Limousine|L|8VS / 8VM|1.6 TDI Diesel|115/85|05/13 - 10/20|1598|D|02/17 - 10/20|
A|A3 Limousine|L|8VS / 8VM|1.6 TDI quattro Diesel|110/81|05/13 - 10/20|1598|D|05/15 - 08/16|
A|A3 Limousine|L|8VS / 8VM|1.8 40 TFSI Petrol|180/132|05/13 - 10/20|1798|P|03/14 - 12/15|
A|A3 Limousine|L|8VS / 8VM|1.8 TFSI Petrol|180/132|05/13 - 10/20|1798|P|05/13 - 08/16|
A|A3 Limousine|L|8VS / 8VM|1.8 TFSI quattro Petrol|180/132|05/13 - 10/20|1798|P|05/13 - 08/16|
A|A3 Limousine|L|8VS / 8VM|2.0 45 TFSI Petrol|220/162|05/13 - 10/20|1984|P|02/15 - 08/16|
A|A3 Limousine|L|8VS / 8VM|2.0 TDI Diesel|110/81|05/13 - 10/20|1968|D|05/13 - 10/20|
A|A3 Limousine|L|8VS / 8VM|2.0 TDI Diesel|136/100|05/13 - 10/20|1968|D|05/13 - 08/16|
A|A3 Limousine|L|8VS / 8VM|2.0 TDI Diesel|143/105|05/13 - 10/20|1968|D|05/13 - 10/20|
A|A3 Limousine|L|8VS / 8VM|2.0 TDI Diesel|150/110|05/13 - 10/20|1968|D|05/13 - 10/20|
A|A3 Limousine|L|8VS / 8VM|2.0 TDI Diesel|184/135|05/13 - 10/20|1968|D|05/13 - 07/18|
A|A3 Limousine|L|8VS / 8VM|2.0 TDI quattro Diesel|150/110|05/13 - 10/20|1968|D|05/13 - 10/20|
A|A3 Limousine|L|8VS / 8VM|2.0 TDI quattro Diesel|184/135|05/13 - 10/20|1968|D|05/13 - 07/18|
A|A3 Limousine|L|8VS / 8VM|2.0 TFSI Petrol|190/140|05/13 - 10/20|1984|P|05/16 - 10/20|
A|A3 Limousine|L|8VS / 8VM|2.0 TFSI quattro Petrol|190/140|05/13 - 10/20|1984|P|05/16 - 10/20|
A|A3 Limousine|L|8VS / 8VM|30 TDI Diesel|115/85|05/13 - 10/20|1598|D|07/18 - 10/20|
A|A3 Limousine|L|8VS / 8VM|30 TFSI Petrol|116/85|05/13 - 10/20|999|P|07/18 - 10/20|
A|A3 Limousine|L|8VS / 8VM|35 TDI Diesel|150/110|05/13 - 10/20|1968|D|07/18 - 10/20|
A|A3 Limousine|L|8VS / 8VM|35 TFSI Petrol|150/110|05/13 - 10/20|1498|P|10/18 - 10/20|
A|A3 Limousine|L|8VS / 8VM|40 TDI quattro Diesel|184/135|05/13 - 10/20|1968|D|07/18 - 10/20|
A|A3 Limousine|L|8VS / 8VM|40 TFSI Petrol|190/140|05/13 - 10/20|1984|P|07/18 - 10/20|
A|A3 Limousine|L|8VS / 8VM|40 TFSI quattro Petrol|190/140|05/13 - 10/20|1984|P|07/18 - 10/20|
A|RS3|L|8VS / 8VM|2.5 TFSI quattro Petrol|367/270|05/13 - 10/20|2480|P|03/15 - 08/16|
A|RS3|L|8VS / 8VM|2.5 TFSI quattro Petrol|400/294|05/13 - 10/20|2480|P|04/17 - 10/20|
A|S3|L|8VS / 8VM|2.0 TFSI quattro Petrol|280/206|05/13 - 10/20|1984|P|05/13 - 08/16|
A|S3|L|8VS / 8VM|2.0 TFSI quattro Petrol|286/210|05/13 - 10/20|1984|P|05/14 - 08/16|
A|S3|L|8VS / 8VM|2.0 TFSI quattro Petrol|290/213|05/13 - 10/20|1984|P|07/16 - 10/20|
A|S3|L|8VS / 8VM|2.0 TFSI quattro Petrol|300/221|05/13 - 10/20|1984|P|10/13 - 10/20|
A|S3|L|8VS / 8VM|2.0 TFSI quattro Petrol|310/228|05/13 - 10/20|1984|P|06/16 - 10/20|
A|A3 Limousine|L|8YS / 8YM|30 TDI Diesel|116/85|04/20 -|1968|D|06/20 -|
A|A3 Limousine|L|8YS / 8YM|30 TFSI Petrol|110/81|04/20 -|999|P|06/20 -|
A|A3 Limousine|L|8YS / 8YM|30 TFSI Petrol|116/85|04/20 -|1498|P|05/24 -|
A|A3 Limousine|L|8YS / 8YM|30 TFSI Mild Hybrid Petrol/Electric|110/81|04/20 -|999|PE|06/20 -|
A|A3 Limousine|L|8YS / 8YM|30 TFSI Mild Hybrid Petrol/Electric|116/85|04/20 -|1498|PE|05/24 -|
A|A3 Limousine|L|8YS / 8YM|35 TDI Diesel|150/110|04/20 -|1968|D|04/20 -|
A|A3 Limousine|L|8YS / 8YM|35 TFSI Petrol (1.4L)|150/110|04/20 -|1395|P|08/20 -|
A|A3 Limousine|L|8YS / 8YM|35 TFSI Petrol (1.5L)|150/110|04/20 -|1498|P|04/20 -|
A|A3 Limousine|L|8YS / 8YM|35 TFSI Mild Hybrid Petrol/Electric|150/110|04/20 -|1498|PE|04/20 -|
A|A3 Limousine|L|8YS / 8YM|40 TDI quattro Diesel|200/147|04/20 -|1968|D|12/20 -|
A|A3 Limousine|L|8YS / 8YM|40 TFSI Petrol|190/140|04/20 -|1984|P|05/21 -|
A|A3 Limousine|L|8YS / 8YM|40 TFSI Petrol|204/150|04/20 -|1984|P|04/21 -|
A|A3 Limousine|L|8YS / 8YM|40 TFSI Mild Hybrid quattro Petrol/Electric|204/150|04/20 -|1984|PE|08/24 -|
A|A3 Limousine|L|8YS / 8YM|40 TFSI quattro Petrol|190/140|04/20 -|1984|P|07/21 -|
A|A3 Limousine|L|8YS / 8YM|40 TFSI quattro Petrol|204/150|04/20 -|1984|P|04/21 -|
A|RS3|L|8YS / 8YM|2.5 TFSI quattro Petrol|400/294|04/20 -|2480|P|07/21 -|
A|RS3|L|8YS / 8YM|2.5 TFSI quattro Petrol|407/299|04/20 -|2480|P|01/22 -|
A|S3|L|8YS / 8YM|2.0 TFSI quattro Petrol|290/213|04/20 -|1984|P|11/20 -|
A|S3|L|8YS / 8YM|2.0 TFSI quattro Petrol|310/228|04/20 -|1984|P|06/20 -|
A|S3|L|8YS / 8YM|2.0 TFSI quattro Petrol|333/245|04/20 -|1984|P|02/24 -|
A|A3 Sportback|S|8PA|1.2 TSI Petrol|105/77|09/04 - 03/13|1197|P|04/10 - 03/13|
A|A3 Sportback|S|8PA|1.4 TFSI Petrol|125/92|09/04 - 03/13|1390|P|09/07 - 03/13|
A|A3 Sportback|S|8PA|1.6 Petrol|102/75|09/04 - 03/13|1595|P|09/04 - 03/13|
A|A3 Sportback|S|8PA|1.6 E-Power Petrol/Ethanol|102/75|09/04 - 03/13|1595|PT|01/11 - 03/13|
A|A3 Sportback|S|8PA|1.6 FSI Petrol|115/85|09/04 - 03/13|1598|P|09/04 - 09/07|
A|A3 Sportback|S|8PA|1.6 TDI Diesel|90/66|09/04 - 03/13|1598|D|05/09 - 03/13|
A|A3 Sportback|S|8PA|1.6 TDI Diesel|105/77|09/04 - 03/13|1598|D|05/09 - 03/13|
A|A3 Sportback|S|8PA|1.8 FSI Petrol|150/110|09/04 - 03/13|1781|P|08/06 - 06/08|
A|A3 Sportback|S|8PA|1.8 TFSI Petrol|160/118|09/04 - 03/13|1798|P|11/06 - 03/13|
A|A3 Sportback|S|8PA|1.8 TFSI quattro Petrol|160/118|09/04 - 03/13|1798|P|07/08 - 03/13|
A|A3 Sportback|S|8PA|1.9 TDI Diesel|105/77|09/04 - 03/13|1896|D|09/04 - 05/10|
A|A3 Sportback|S|8PA|2.0 FSI Petrol|150/110|09/04 - 03/13|1984|P|09/04 - 06/08|
A|A3 Sportback|S|8PA|2.0 TDI Diesel|136/100|09/04 - 03/13|1968|D|09/04 - 03/13|
A|A3 Sportback|S|8PA|2.0 TDI Diesel|140/103|09/04 - 03/13|1968|D|06/05 - 06/08|
A|A3 Sportback|S|8PA|2.0 TDI Diesel|141/104|09/04 - 03/13|1968|D|01/10 - 03/13|
A|A3 Sportback|S|8PA|2.0 TDI Diesel|163/120|09/04 - 03/13|1968|D|06/06 - 06/08|
A|A3 Sportback|S|8PA|2.0 TDI Diesel|170/125|09/04 - 03/13|1968|D|03/06 - 03/13|
A|A3 Sportback|S|8PA|2.0 TDI 16V Diesel|140/103|09/04 - 03/13|1968|D|09/04 - 03/13|
A|A3 Sportback|S|8PA|2.0 TDI 16V quattro Diesel|140/103|09/04 - 03/13|1968|D|11/05 - 03/13|
A|A3 Sportback|S|8PA|2.0 TDI quattro Diesel|140/103|09/04 - 03/13|1968|D|01/06 - 06/08|
A|A3 Sportback|S|8PA|2.0 TDI quattro Diesel|170/125|09/04 - 03/13|1968|D|03/06 - 03/13|
A|A3 Sportback|S|8PA|2.0 TFSI Petrol|200/147|09/04 - 03/13|1984|P|09/04 - 03/13|
A|A3 Sportback|S|8PA|2.0 TFSI quattro Petrol|200/147|09/04 - 03/13|1984|P|09/04 - 03/13|
A|A3 Sportback|S|8PA|3.2 V6 quattro Petrol|250/184|09/04 - 03/13|3189|P|09/04 - 05/09|
A|RS3|S|8PA|2.5 TFSI quattro Petrol|340/250|09/04 - 03/13|2480|P|01/11 - 12/12|
A|S3|S|8PA|2.0 TFSI quattro Petrol|256/188|09/04 - 03/13|1984|P|07/08 - 03/13|
A|S3|S|8PA|2.0 TFSI quattro Petrol|265/195|09/04 - 03/13|1984|P|06/08 - 03/13|
A|A3 Sportback|S|8VA / 8VF|1.0 TFSI Petrol|115/85|09/12 - 10/20|999|P|07/16 - 10/20|
A|A3 Sportback|S|8VA / 8VF|1.2 TFSI Petrol|105/77|09/12 - 10/20|1197|P|05/13 - 05/15|
A|A3 Sportback|S|8VA / 8VF|1.2 TFSI Petrol|110/81|09/12 - 10/20|1197|P|05/14 - 08/16|
A|A3 Sportback|S|8VA / 8VF|1.4 TFSI Petrol|122/90|09/12 - 10/20|1395|P|09/12 - 10/20|
A|A3 Sportback|S|8VA / 8VF|1.4 TFSI Petrol|125/92|09/12 - 10/20|1395|P|05/14 - 08/16|
A|A3 Sportback|S|8VA / 8VF|1.4 TFSI Petrol|140/103|09/12 - 10/20|1395|P|03/13 - 11/14|
A|A3 Sportback|S|8VA / 8VF|1.4 TFSI e-tron Petrol/Electric|204/150|09/12 - 10/20|1395|PE|05/14 - 10/20|
A|A3 Sportback|S|8VA / 8VF|1.4 TFSI g-tron Petrol/CNG|110/81|09/12 - 10/20|1395|PC|11/13 - 10/20|
A|A3 Sportback|S|8VA / 8VF|1.4 TSI Petrol|150/110|09/12 - 10/20|1395|P|05/14 - 10/20|
A|A3 Sportback|S|8VA / 8VF|1.5 TFSI Petrol|150/110|09/12 - 10/20|1498|P|05/17 - 10/18|
A|A3 Sportback|S|8VA / 8VF|1.6 TDI Diesel|105/77|09/12 - 10/20|1598|D|10/12 - 12/16|
A|A3 Sportback|S|8VA / 8VF|1.6 TDI Diesel|110/81|09/12 - 10/20|1598|D|09/13 - 10/20|
A|A3 Sportback|S|8VA / 8VF|1.6 TDI Diesel|115/85|09/12 - 10/20|1598|D|02/17 - 10/20|
A|A3 Sportback|S|8VA / 8VF|1.6 TDI quattro Diesel|110/81|09/12 - 10/20|1598|D|05/15 - 08/16|
A|A3 Sportback|S|8VA / 8VF|1.8 40 TFSI Petrol|180/132|09/12 - 10/20|1798|P|03/14 - 12/15|
A|A3 Sportback|S|8VA / 8VF|1.8 TFSI Petrol|180/132|09/12 - 10/20|1798|P|09/12 - 08/16|
A|A3 Sportback|S|8VA / 8VF|1.8 TFSI quattro Petrol|180/132|09/12 - 10/20|1798|P|05/13 - 08/16|
A|A3 Sportback|S|8VA / 8VF|2.0 45 TFSI Petrol|220/162|09/12 - 10/20|1984|P|02/15 - 08/16|
A|A3 Sportback|S|8VA / 8VF|2.0 TDI Diesel|110/81|09/12 - 10/20|1968|D|05/13 - 10/20|
A|A3 Sportback|S|8VA / 8VF|2.0 TDI Diesel|136/100|09/12 - 10/20|1968|D|05/13 - 08/16|
A|A3 Sportback|S|8VA / 8VF|2.0 TDI Diesel|143/105|09/12 - 10/20|1968|D|03/13 - 10/20|
A|A3 Sportback|S|8VA / 8VF|2.0 TDI Diesel|150/110|09/12 - 10/20|1968|D|09/12 - 10/20|
A|A3 Sportback|S|8VA / 8VF|2.0 TDI Diesel|184/135|09/12 - 10/20|1968|D|05/13 - 07/18|
A|A3 Sportback|S|8VA / 8VF|2.0 TDI quattro Diesel|150/110|09/12 - 10/20|1968|D|02/13 - 10/20|
A|A3 Sportback|S|8VA / 8VF|2.0 TDI quattro Diesel|184/135|09/12 - 10/20|1968|D|05/13 - 07/18|
A|A3 Sportback|S|8VA / 8VF|2.0 TFSI Petrol|190/140|09/12 - 10/20|1984|P|05/16 - 10/20|
A|A3 Sportback|S|8VA / 8VF|2.0 TFSI quattro Petrol|190/140|09/12 - 10/20|1984|P|05/16 - 10/20|
A|A3 Sportback|S|8VA / 8VF|30 g-tron Petrol/CNG|131/96|09/12 - 10/20|1498|PC|11/18 - 10/20|
A|A3 Sportback|S|8VA / 8VF|30 TDI Diesel|115/85|09/12 - 10/20|1598|D|07/18 - 10/20|
A|A3 Sportback|S|8VA / 8VF|30 TFSI Petrol|116/85|09/12 - 10/20|999|P|07/18 - 10/20|
A|A3 Sportback|S|8VA / 8VF|35 TDI Diesel|150/110|09/12 - 10/20|1968|D|07/18 - 10/20|
A|A3 Sportback|S|8VA / 8VF|35 TFSI Petrol|150/110|09/12 - 10/20|1498|P|10/18 - 10/20|
A|A3 Sportback|S|8VA / 8VF|40 e-tron Petrol/Electric|204/150|09/12 - 10/20|1395|PE|07/18 - 10/20|
A|A3 Sportback|S|8VA / 8VF|40 TDI quattro Diesel|184/135|09/12 - 10/20|1968|D|07/18 - 10/20|
A|A3 Sportback|S|8VA / 8VF|40 TFSI Petrol|190/140|09/12 - 10/20|1984|P|07/18 - 10/20|
A|A3 Sportback|S|8VA / 8VF|40 TFSI quattro Petrol|190/140|09/12 - 10/20|1984|P|07/18 - 10/20|
A|RS3|S|8VA / 8VF|2.5 TFSI quattro Petrol|367/270|09/12 - 10/20|2480|P|03/15 - 08/16|
A|RS3|S|8VA / 8VF|2.5 TFSI quattro Petrol|400/294|09/12 - 10/20|2480|P|04/17 - 10/20|
A|S3|S|8VA / 8VF|2.0 TFSI quattro Petrol|280/206|09/12 - 10/20|1984|P|05/13 - 08/16|
A|S3|S|8VA / 8VF|2.0 TFSI quattro Petrol|286/210|09/12 - 10/20|1984|P|05/14 - 08/16|
A|S3|S|8VA / 8VF|2.0 TFSI quattro Petrol|290/213|09/12 - 10/20|1984|P|07/16 - 10/20|
A|S3|S|8VA / 8VF|2.0 TFSI quattro Petrol|300/221|09/12 - 10/20|1984|P|11/12 - 10/20|
A|S3|S|8VA / 8VF|2.0 TFSI quattro Petrol|310/228|09/12 - 10/20|1984|P|06/16 - 10/20|
A|A3 Sportback|S|8YA / 8YF|2.0 40 TFSI Petrol|204/150|11/19 -|1984|P|05/22 -|
A|A3 Sportback|S|8YA / 8YF|30 g-tron Petrol/CNG|131/96|11/19 -|1498|PC|07/20 -|
A|A3 Sportback|S|8YA / 8YF|30 TDI Diesel|116/85|11/19 -|1968|D|11/19 -|
A|A3 Sportback|S|8YA / 8YF|30 TFSI Petrol|110/81|11/19 -|999|P|06/20 -|
A|A3 Sportback|S|8YA / 8YF|30 TFSI Petrol|116/85|11/19 -|1498|P|05/24 -|
A|A3 Sportback|S|8YA / 8YF|30 TFSI Mild Hybrid Petrol/Electric|110/81|11/19 -|999|PE|06/20 -|
A|A3 Sportback|S|8YA / 8YF|30 TFSI Mild Hybrid Petrol/Electric|116/85|11/19 -|1498|PE|05/24 -|
A|A3 Sportback|S|8YA / 8YF|35 TDI Diesel|150/110|11/19 -|1968|D|11/19 -|
A|A3 Sportback|S|8YA / 8YF|35 TFSI Petrol (1.4L)|150/110|11/19 -|1395|P|08/21 -|
A|A3 Sportback|S|8YA / 8YF|35 TFSI Petrol (1.5L)|150/110|11/19 -|1498|P|11/19 -|
A|A3 Sportback|S|8YA / 8YF|35 TFSI Mild Hybrid Petrol/Electric|150/110|11/19 -|1498|PE|04/20 -|
A|A3 Sportback|S|8YA / 8YF|40 TDI quattro Diesel|200/147|11/19 -|1968|D|12/20 -|
A|A3 Sportback|S|8YA / 8YF|40 TFSI Petrol|190/140|11/19 -|1984|P|05/21 -|
A|A3 Sportback|S|8YA / 8YF|40 TFSI quattro Petrol|190/140|11/19 -|1984|P|07/21 -|
A|A3 Sportback|S|8YA / 8YF|40 TFSI quattro Petrol|204/150|11/19 -|1984|P|08/24 -|
A|A3 Sportback|S|8YA / 8YF|40 TFSIe Petrol/Electric (1.4L)|204/150|11/19 -|1395|PE|06/20 -|
A|A3 Sportback|S|8YA / 8YF|40 TFSIe Petrol/Electric (1.5L)|204/150|11/19 -|1498|PE|06/24 -|
A|A3 Sportback|S|8YA / 8YF|45 TFSIe Petrol/Electric|245/180|11/19 -|1395|PE|07/21 -|
A|A3 Sportback|S|8YA / 8YF|45 TFSIe Petrol/Electric|272/200|11/19 -|1498|PE|11/24 -|
A|RS3|S|8YA / 8YF|2.5 TFSI quattro Petrol|400/294|11/19 -|2480|P|07/21 -|
A|RS3|S|8YA / 8YF|2.5 TFSI quattro Petrol|407/299|11/19 -|2480|P|11/22 -|
A|S3|S|8YA / 8YF|2.0 TFSI quattro Petrol|290/213|11/19 -|1984|P|07/20 -|
A|S3|S|8YA / 8YF|2.0 TFSI quattro Petrol|310/228|11/19 -|1984|P|06/20 -|
A|S3|S|8YA / 8YF|2.0 TFSI quattro Petrol|333/245|11/19 -|1984|P|02/24 -|
A|A4 Allroad||8KH|2.0 TDI quattro Diesel|136/100|04/09 - 05/16|1968|D|09/09 - 05/16|CAGB
A|A4 Allroad||8KH|2.0 TDI quattro Diesel|143/105|04/09 - 05/16|1968|D|09/09 - 05/16|CAGA
A|A4 Allroad||8KH|2.0 TDI quattro Diesel|150/110|04/09 - 05/16|1968|D|05/13 - 05/16|CJCD
A|A4 Allroad||8KH|2.0 TDI quattro Diesel|163/120|04/09 - 05/16|1968|D|04/09 - 05/16|CAHB
A|A4 Allroad||8KH|2.0 TDI quattro Diesel|170/125|04/09 - 05/16|1968|D|04/09 - 05/16|CAHA
A|A4 Allroad||8KH|2.0 TDI quattro Diesel|177/130|04/09 - 05/16|1968|D|11/11 - 05/16|CGLC
A|A4 Allroad||8KH|2.0 TDI quattro Diesel|190/140|04/09 - 05/16|1968|D|09/13 - 05/16|CNHA
A|A4 Allroad||8KH|2.0 TFSI Flexfuel quattro Petrol/Ethanol|211/155|04/09 - 05/16|1984|PT|09/12 - 12/13|CPMA
A|A4 Allroad||8KH|2.0 TFSI Flexfuel quattro Petrol/Ethanol|220/162|04/09 - 05/16|1984|PT|05/13 - 05/16|CPMB
A|A4 Allroad||8KH|2.0 TFSI quattro Petrol|211/155|04/09 - 05/16|1984|P|04/09 - 05/16|CDNC
A|A4 Allroad||8KH|2.0 TFSI quattro Petrol|220/162|04/09 - 05/16|1984|P|05/13 - 05/16|CPMB
A|A4 Allroad||8KH|2.0 TFSI quattro Petrol|224/165|04/09 - 05/16|1984|P|05/13 - 05/16|CNCD
A|A4 Allroad||8KH|3.0 TDI quattro Diesel|240/176|04/09 - 05/16|2967|D|04/09 - 01/12|CCWA
A|A4 Allroad||8KH|3.0 TDI quattro Diesel|245/180|04/09 - 05/16|2967|D|01/12 - 05/16|CDUC
A|A4 Allroad||8WH / 8WJ|2.0 TDI quattro Diesel|136/100|01/16 -|1968|D|11/16 - 07/18|DEUB
A|A4 Allroad||8WH / 8WJ|2.0 TDI quattro Diesel|150/110|01/16 -|1968|D|11/16 - 10/19|DEUA
A|A4 Allroad||8WH / 8WJ|2.0 TDI quattro Diesel|163/120|01/16 -|1968|D|05/16 - 10/19|DETB
A|A4 Allroad||8WH / 8WJ|2.0 TDI quattro Diesel|190/140|01/16 -|1968|D|01/16 - 12/19|DESA
A|A4 Allroad||8WH / 8WJ|2.0 TFSI Mild Hybrid quattro Petrol/Electric|252/185|01/16 -|1984|PE|11/18 - 10/19|DDWA
A|A4 Allroad||8WH / 8WJ|2.0 TFSI quattro Petrol|249/183|01/16 -|1984|P|05/16 - 10/19|CYRC
A|A4 Allroad||8WH / 8WJ|2.0 TFSI quattro Petrol|252/185|01/16 -|1984|P|01/16 -|CYMC
A|A4 Allroad||8WH / 8WJ|3.0 TDI quattro Diesel|218/160|01/16 -|2967|D|01/16 - 08/18|CSWB
A|A4 Allroad||8WH / 8WJ|3.0 TDI quattro Diesel|272/200|01/16 -|2967|D|01/16 - 08/18|CRTC
A|A4 Allroad||8WH / 8WJ|3.0 TDI quattro Diesel|286/210|01/16 -|2967|D|07/18 - 10/19|DCPC
A|A4 Allroad||8WH / 8WJ|40 TDI Mild Hybrid quattro Diesel/Electric|204/150|01/16 -|1968|DE|09/20 -|DTPA
A|A4 Allroad||8WH / 8WJ|40 TDI quattro Diesel|190/140|01/16 -|1968|D|01/20 -|DETA
A|A4 Allroad||8WH / 8WJ|45 TDI quattro Diesel|231/170|01/16 -|2967|D|07/18 -|DCPE
A|A4 Allroad||8WH / 8WJ|45 TFSI Mild Hybrid quattro Petrol/Electric|245/180|01/16 -|1984|PE|07/18 -|DKNA
A|A4 Allroad||8WH / 8WJ|45 TFSI Mild Hybrid quattro Petrol/Electric|249/183|01/16 -|1984|PE|02/20 -|DDWA
A|A4 Allroad||8WH / 8WJ|45 TFSI Mild Hybrid quattro Petrol/Electric|265/195|01/16 -|1984|PE|08/20 -|DMTA
A|A4 Allroad||8WH / 8WJ|45 TFSI quattro Petrol|265/195|01/16 -|1984|P|10/22 -|DMTA
A|A4 Allroad||8WH / 8WJ|50 TDI Mild Hybrid quattro Diesel/Electric|286/210|01/16 -|2967|DE|08/20 -|DMGA
A|A4 Allroad||8WH / 8WJ|50 TDI quattro Diesel|286/210|01/16 -|2967|D|11/19 -|DCPC
A|A4||8D2|1.6 Petrol|100/74|11/94 - 09/01|1595|P|11/94 - 10/00|ADP
A|A4||8D2|1.6 Petrol|102/75|11/94 - 09/01|1595|P|07/00 - 11/00|ALZ
A|A4||8D2|1.8 Petrol|115/85|11/94 - 09/01|1781|P|04/95 - 11/00|AFY
A|A4||8D2|1.8 Petrol|125/92|11/94 - 09/01|1781|P|11/94 - 11/00|ADR
A|A4||8D2|1.8 quattro Petrol|115/85|11/94 - 09/01|1781|P|07/95 - 11/00|AFY
A|A4||8D2|1.8 quattro Petrol|125/92|11/94 - 09/01|1781|P|01/95 - 11/00|ADR
A|A4||8D2|1.8 T Petrol|150/110|11/94 - 09/01|1781|P|01/95 - 11/00|AEB
A|A4||8D2|1.8 T Petrol|180/132|11/94 - 09/01|1781|P|12/97 - 11/00|AJL
A|A4||8D2|1.8 T quattro Petrol|150/110|11/94 - 09/01|1781|P|01/95 - 11/00|AEB
A|A4||8D2|1.8 T quattro Petrol|170/125|11/94 - 09/01|1781|P|09/00 - 12/01|AWM
A|A4||8D2|1.8 T quattro Petrol|180/132|11/94 - 09/01|1781|P|12/97 - 11/00|AJL
A|A4||8D2|1.9 TDI Diesel|75/55|11/94 - 09/01|1896|D|12/95 - 11/00|AFF
A|A4||8D2|1.9 TDI Diesel|90/66|11/94 - 09/01|1896|D|01/95 - 11/00|1Z
A|A4||8D2|1.9 TDI Diesel|110/81|11/94 - 09/01|1896|D|10/95 - 11/00|AFN
A|A4||8D2|1.9 TDI Diesel|116/85|11/94 - 09/01|1896|D|03/00 - 11/00|AJM
A|A4||8D2|1.9 TDI quattro Diesel|110/81|11/94 - 09/01|1896|D|07/96 - 01/00|AFN
A|A4||8D2|1.9 TDI quattro Diesel|116/85|11/94 - 09/01|1896|D|03/00 - 11/00|AJM
A|A4||8D2|2.4 Petrol|150/110|11/94 - 09/01|2393|P|07/95 - 07/97|AFM
A|A4||8D2|2.4 Petrol|163/120|11/94 - 09/01|2393|P|08/97 - 11/00|AJG
A|A4||8D2|2.4 Petrol|165/121|11/94 - 09/01|2393|P|03/97 - 11/00|AGA
A|A4||8D2|2.4 quattro Petrol|163/120|11/94 - 09/01|2393|P|08/97 - 11/00|AJG
A|A4||8D2|2.4 quattro Petrol|165/121|11/94 - 09/01|2393|P|03/97 - 11/00|AGA
A|A4||8D2|2.5 TDI Diesel|150/110|11/94 - 09/01|2496|D|09/97 - 11/00|AFB
A|A4||8D2|2.5 TDI quattro Diesel|150/110|11/94 - 09/01|2496|D|09/97 - 11/00|AFB
A|A4||8D2|2.6 Petrol|139/102|11/94 - 09/01|2598|P|01/96 - 07/97|ACZ
A|A4||8D2|2.6 Petrol|150/110|11/94 - 09/01|2598|P|01/95 - 11/00|ABC
A|A4||8D2|2.6 quattro Petrol|150/110|11/94 - 09/01|2598|P|01/95 - 11/00|ABC
A|A4||8D2|2.7 Turbo quattro Petrol|230/169|11/94 - 09/01|2671|P|02/99 - 09/00|AJK
A|A4||8D2|2.8 Petrol|174/128|11/94 - 09/01|2771|P|09/95 - 07/97|AAH
A|A4||8D2|2.8 Petrol|190/140|11/94 - 09/01|2771|P|09/99 - 10/00|ATX
A|A4||8D2|2.8 Petrol|193/142|11/94 - 09/01|2771|P|10/96 - 11/00|ACK
A|A4||8D2|2.8 quattro Petrol|174/128|11/94 - 09/01|2771|P|01/95 - 07/97|AAH
A|A4||8D2|2.8 quattro Petrol|190/140|11/94 - 09/01|2771|P|09/99 - 10/00|ATX
A|A4||8D2|2.8 quattro Petrol|193/142|11/94 - 09/01|2771|P|10/96 - 08/01|ACK
A|S4||8D2|2.7 TFSI quattro Petrol|254/187|11/94 - 09/01|2671|P|10/97 - 12/98|APB
A|S4||8D2|2.7 TFSI quattro Petrol|265/195|11/94 - 09/01|2671|P|09/97 - 09/01|AGB
A|A4 Avant||8D5|1.6 Petrol|100/74|11/94 - 09/01|1595|P|11/94 - 09/01|ADP
A|A4 Avant||8D5|1.6 Petrol|102/75|11/94 - 09/01|1595|P|07/00 - 09/01|ALZ
A|A4 Avant||8D5|1.8 Petrol|115/85|11/94 - 09/01|1781|P|07/95 - 09/01|AFY
A|A4 Avant||8D5|1.8 Petrol|125/92|11/94 - 09/01|1781|P|02/96 - 09/01|ADR
A|A4 Avant||8D5|1.8 quattro Petrol|115/85|11/94 - 09/01|1781|P|07/95 - 09/01|AFY
A|A4 Avant||8D5|1.8 quattro Petrol|125/92|11/94 - 09/01|1781|P|01/96 - 09/01|ADR
A|A4 Avant||8D5|1.8 T Petrol|150/110|11/94 - 09/01|1781|P|03/96 - 09/01|AEB
A|A4 Avant||8D5|1.8 T Petrol|180/132|11/94 - 09/01|1781|P|12/97 - 09/01|AJL
A|A4 Avant||8D5|1.8 T quattro Petrol|150/110|11/94 - 09/01|1781|P|01/96 - 09/01|AEB
A|A4 Avant||8D5|1.8 T quattro Petrol|180/132|11/94 - 09/01|1781|P|12/97 - 09/01|AJL
A|A4 Avant||8D5|1.9 Hybrid Diesel/Electric|90/66|11/94 - 09/01|1896|DE|03/98 - 06/00|AHU
A|A4 Avant||8D5|1.9 TDI Diesel|90/66|11/94 - 09/01|1896|D|02/96 - 09/01|1Z
A|A4 Avant||8D5|1.9 TDI Diesel|110/81|11/94 - 09/01|1896|D|02/96 - 09/01|AFN
A|A4 Avant||8D5|1.9 TDI Diesel|115/85|11/94 - 09/01|1896|D|03/00 - 09/01|AJM
A|A4 Avant||8D5|1.9 TDI quattro Diesel|110/81|11/94 - 09/01|1896|D|09/96 - 09/01|AFN
A|A4 Avant||8D5|1.9 TDI quattro Diesel|115/85|11/94 - 09/01|1896|D|03/00 - 09/01|AJM
A|A4 Avant||8D5|2.4 Petrol|150/110|11/94 - 09/01|2393|P|07/95 - 07/97|AFM
A|A4 Avant||8D5|2.4 Petrol|163/120|11/94 - 09/01|2393|P|08/97 - 09/01|AJG
A|A4 Avant||8D5|2.4 Petrol|165/121|11/94 - 09/01|2393|P|03/97 - 09/01|AGA
A|A4 Avant||8D5|2.4 quattro Petrol|163/120|11/94 - 09/01|2393|P|08/97 - 09/01|AJG
A|A4 Avant||8D5|2.4 quattro Petrol|165/121|11/94 - 09/01|2393|P|03/97 - 09/01|AGA
A|A4 Avant||8D5|2.5 TDI Diesel|150/110|11/94 - 09/01|2496|D|09/97 - 09/01|AFB
A|A4 Avant||8D5|2.5 TDI quattro Diesel|150/110|11/94 - 09/01|2496|D|09/97 - 09/01|AFB
A|A4 Avant||8D5|2.6 Petrol|139/102|11/94 - 09/01|2598|P|01/96 - 07/97|ACZ
A|A4 Avant||8D5|2.6 Petrol|150/110|11/94 - 09/01|2598|P|02/96 - 09/01|ABC
A|A4 Avant||8D5|2.6 quattro Petrol|150/110|11/94 - 09/01|2598|P|01/96 - 09/01|ABC
A|A4 Avant||8D5|2.8 Petrol|190/140|11/94 - 09/01|2771|P|03/99 - 09/00|ATX
A|A4 Avant||8D5|2.8 Petrol|193/142|11/94 - 09/01|2771|P|10/96 - 09/01|ACK
A|A4 Avant||8D5|2.8 quattro Petrol|190/140|11/94 - 09/01|2771|P|03/99 - 09/00|ATX
A|A4 Avant||8D5|2.8 quattro Petrol|193/142|11/94 - 09/01|2771|P|10/96 - 09/01|ACK
A|RS4 Avant||8D5|2.7 TFSI quattro Petrol|380/280|11/94 - 09/01|2671|P|05/00 - 09/01|ASJ
A|S4 Avant||8D5|2.7 TFSI quattro Petrol|252/185|11/94 - 09/01|2671|P|01/01 - 12/02|APB
A|S4 Avant||8D5|2.7 TFSI quattro Petrol|265/195|11/94 - 09/01|2671|P|09/97 - 09/01|AGB
A|A4||8E2|1.6 Petrol|102/75|11/00 - 12/04|1595|P|11/00 - 12/04|ALZ
A|A4||8E2|1.8 T Petrol|150/110|11/00 - 12/04|1781|P|11/00 - 07/02|AVJ
A|A4||8E2|1.8 T Petrol|163/120|11/00 - 12/04|1781|P|07/02 - 12/04|BFB
A|A4||8E2|1.8 T Petrol|170/125|11/00 - 12/04|1781|P|07/01 - 12/04|AMB
A|A4||8E2|1.8 T Petrol|173/127|11/00 - 12/04|1781|P|01/01 - 12/04|AWM
A|A4||8E2|1.8 T Petrol|190/140|11/00 - 12/04|1781|P|11/02 - 12/04|BEX
A|A4||8E2|1.8 T quattro Petrol|150/110|11/00 - 12/04|1781|P|11/00 - 07/02|AVJ
A|A4||8E2|1.8 T quattro Petrol|163/120|11/00 - 12/04|1781|P|07/02 - 12/04|BFB
A|A4||8E2|1.8 T quattro Petrol|170/125|11/00 - 12/04|1781|P|07/01 - 12/04|AMB
A|A4||8E2|1.8 T quattro Petrol|190/140|11/00 - 12/04|1781|P|11/02 - 12/04|BEX
A|A4||8E2|1.9 TDI Diesel|101/74|11/00 - 12/04|1896|D|05/01 - 12/04|AVB
A|A4||8E2|1.9 TDI Diesel|116/85|11/00 - 12/04|1896|D|06/04 - 12/04|BKE
A|A4||8E2|1.9 TDI Diesel|130/96|11/00 - 12/04|1896|D|11/00 - 12/04|AVF
A|A4||8E2|1.9 TDI quattro Diesel|130/96|11/00 - 12/04|1896|D|11/01 - 12/04|AVF
A|A4||8E2|2.0 Petrol|130/96|11/00 - 12/04|1984|P|11/00 - 12/04|ALT
A|A4||8E2|2.0 FSI Petrol|150/110|11/00 - 12/04|1984|P|07/02 - 12/04|AWA
A|A4||8E2|2.4 Petrol|163/120|11/00 - 12/04|2393|P|09/01 - 12/04|AMM
A|A4||8E2|2.4 Petrol|170/125|11/00 - 12/04|2393|P|09/01 - 12/04|BDV
A|A4||8E2|2.5 TDI Diesel|155/114|11/00 - 12/04|2496|D|08/01 - 07/02|AYM
A|A4||8E2|2.5 TDI Diesel|163/120|11/00 - 12/04|2496|D|07/02 - 12/04|BCZ
A|A4||8E2|2.5 TDI quattro Diesel|180/132|11/00 - 12/04|2496|D|11/00 - 12/04|AKE
A|A4||8E2|3.0 Petrol|218/160|11/00 - 12/04|2976|P|04/01 - 12/04|BBJ
A|A4||8E2|3.0 Petrol|220/162|11/00 - 12/04|2976|P|11/00 - 12/04|ASN
A|A4||8E2|3.0 Petrol|223/164|11/00 - 12/04|2976|P|01/05 - 12/05|BGN
A|A4||8E2|3.0 quattro Petrol|218/160|11/00 - 12/04|2976|P|04/01 - 12/04|BBJ
A|A4||8E2|3.0 quattro Petrol|220/162|11/00 - 12/04|2976|P|11/00 - 12/04|ASN
A|A4||8E2|3.0 quattro Petrol|223/164|11/00 - 12/04|2976|P|01/05 - 12/05|BGN
A|S4||8E2|2.7 TFSI quattro Petrol|250/184|11/00 - 12/04|2671|P|09/01 - 12/05|APB
A|S4||8E2|2.7 TFSI quattro Petrol|253/186|11/00 - 12/04|2671|P|11/00 - 12/01|APB
A|S4||8E2|2.7 TFSI quattro Petrol|254/187|11/00 - 12/04|2671|P|11/00 - 12/02|APB
A|S4||8E2|4.2 quattro Petrol|344/253|11/00 - 12/04|4163|P|03/03 - 12/04|BBK
A|A4 Avant||8E5|1.6 Petrol|102/75|04/01 - 12/04|1595|P|09/01 - 12/04|ALZ
A|A4 Avant||8E5|1.8 T Petrol|150/110|04/01 - 12/04|1781|P|09/01 - 07/02|AVJ
A|A4 Avant||8E5|1.8 T Petrol|163/120|04/01 - 12/04|1781|P|07/02 - 12/04|BFB
A|A4 Avant||8E5|1.8 T Petrol|190/140|04/01 - 12/04|1781|P|11/02 - 12/04|BEX
A|A4 Avant||8E5|1.8 T quattro Petrol|150/110|04/01 - 12/04|1781|P|09/01 - 07/02|AVJ
A|A4 Avant||8E5|1.8 T quattro Petrol|163/120|04/01 - 12/04|1781|P|07/02 - 12/04|BFB
A|A4 Avant||8E5|1.8 T quattro Petrol|170/125|04/01 - 12/04|1781|P|09/01 - 12/04|AMB
A|A4 Avant||8E5|1.8 T quattro Petrol|173/127|04/01 - 12/04|1781|P|04/01 - 12/04|AWM
A|A4 Avant||8E5|1.8 T quattro Petrol|190/140|04/01 - 12/04|1781|P|11/02 - 12/04|BEX
A|A4 Avant||8E5|1.9 TDI Diesel|101/74|04/01 - 12/04|1896|D|11/01 - 12/04|AVB
A|A4 Avant||8E5|1.9 TDI Diesel|116/85|04/01 - 12/04|1896|D|06/04 - 12/04|BKE
A|A4 Avant||8E5|1.9 TDI Diesel|130/96|04/01 - 12/04|1896|D|09/01 - 12/04|AVF
A|A4 Avant||8E5|1.9 TDI quattro Diesel|130/96|04/01 - 12/04|1896|D|11/01 - 12/04|AVF
A|A4 Avant||8E5|2.0 Petrol|130/96|04/01 - 12/04|1984|P|09/01 - 12/04|ALT
A|A4 Avant||8E5|2.0 FSI Petrol|150/110|04/01 - 12/04|1984|P|07/02 - 12/04|AWA
A|A4 Avant||8E5|2.4 Petrol|163/120|04/01 - 12/04|2393|P|09/01 - 12/04|AMM
A|A4 Avant||8E5|2.4 Petrol|170/125|04/01 - 12/04|2393|P|09/01 - 12/04|BDV
A|A4 Avant||8E5|2.5 TDI Diesel|155/114|04/01 - 12/04|2496|D|09/01 - 07/02|AYM
A|A4 Avant||8E5|2.5 TDI Diesel|163/120|04/01 - 12/04|2496|D|07/02 - 12/04|BCZ
A|A4 Avant||8E5|2.5 TDI quattro Diesel|180/132|04/01 - 12/04|2496|D|09/01 - 12/04|AKE
A|A4 Avant||8E5|2.7 S4 quattro Petrol|254/187|04/01 - 12/04|2671|P|04/01 - 12/02|APB
A|A4 Avant||8E5|3.0 Petrol|218/160|04/01 - 12/04|2976|P|04/01 - 12/04|BBJ
A|A4 Avant||8E5|3.0 Petrol|220/162|04/01 - 12/04|2976|P|09/01 - 12/04|ASN
A|A4 Avant||8E5|3.0 quattro Petrol|218/160|04/01 - 12/04|2976|P|04/01 - 12/04|BBJ
A|A4 Avant||8E5|3.0 quattro Petrol|220/162|04/01 - 12/04|2976|P|09/01 - 12/04|ASN
A|A4 Avant||8E5|3.0 quattro Petrol|223/164|04/01 - 12/04|2976|P|09/01 - 12/04|AVK
A|S4 Avant||8E5|4.2 quattro Petrol|344/253|04/01 - 12/04|4163|P|03/03 - 12/04|BBK
A|A4 Convertible||8H7|1.8 T Petrol|163/120|04/02 - 03/09|1781|P|07/02 - 12/05|BFB
A|A4 Convertible||8H7|1.8 T Petrol|170/125|04/02 - 03/09|1781|P|10/02 - 10/05|AMB
A|A4 Convertible||8H7|1.8 T quattro Petrol|163/120|04/02 - 03/09|1781|P|05/03 - 12/05|BFB
A|A4 Convertible||8H7|1.8 T quattro Petrol|173/127|04/02 - 03/09|1781|P|09/03 - 12/04|AMB
A|A4 Convertible||8H7|2.0 Petrol|130/96|04/02 - 03/09|1984|P|09/04 - 12/05|ALT
A|A4 Convertible||8H7|2.4 Petrol|163/120|04/02 - 03/09|2393|P|04/02 - 12/05|AMM
A|A4 Convertible||8H7|2.4 Petrol|170/125|04/02 - 03/09|2393|P|04/02 - 12/05|BDV
A|A4 Convertible||8H7|2.5 TDI Diesel|163/120|04/02 - 03/09|2496|D|08/02 - 12/05|BCZ
A|A4 Convertible||8H7|3.0 Petrol|218/160|04/02 - 03/09|2976|P|04/02 - 12/05|BBJ
A|A4 Convertible||8H7|3.0 Petrol|220/162|04/02 - 03/09|2976|P|04/02 - 12/05|ASN
A|A4 Convertible||8H7|3.0 quattro Petrol|220/162|04/02 - 03/09|2976|P|05/03 - 12/05|ASN
A|S4 Convertible||8H7|4.2 quattro Petrol|344/253|04/02 - 03/09|4163|P|03/04 - 12/05|BBK
A|A4||8EC|1.6 Petrol|102/75|11/04 - 06/08|1595|P|11/04 - 06/08|ALZ
A|A4||8EC|1.8 T Petrol|163/120|11/04 - 06/08|1781|P|11/04 - 06/08|BFB
A|A4||8EC|1.8 T Petrol|170/125|11/04 - 06/08|1781|P|01/05 - 12/05|AMB
A|A4||8EC|1.8 T quattro Petrol|163/120|11/04 - 06/08|1781|P|11/04 - 06/08|BFB
A|A4||8EC|1.9 TDI Diesel|116/85|11/04 - 06/08|1896|D|11/04 - 06/08|BKE
A|A4||8EC|2.0 Petrol|130/96|11/04 - 06/08|1984|P|11/04 - 06/08|ALT
A|A4||8EC|2.0 FSI Petrol|150/110|11/04 - 06/08|1984|P|01/05 - 07/05|AWA
A|A4||8EC|2.0 TDI Diesel|121/89|11/04 - 06/08|1968|D|09/05 - 09/06|BVG
A|A4||8EC|2.0 TDI Diesel|126/93|11/04 - 06/08|1968|D|11/05 - 11/06|BVF
A|A4||8EC|2.0 TDI Diesel|136/100|11/04 - 06/08|1968|D|11/04 - 06/08|BNA
A|A4||8EC|2.0 TDI Diesel|140/103|11/04 - 06/08|1968|D|11/04 - 06/08|BPW
A|A4||8EC|2.0 TDI Diesel|163/120|11/04 - 06/08|1968|D|06/06 - 06/08|BVA
A|A4||8EC|2.0 TDI Diesel|170/125|11/04 - 06/08|1968|D|06/06 - 06/08|BRD
A|A4||8EC|2.0 TDI 16V Diesel|140/103|11/04 - 06/08|1968|D|11/04 - 06/08|BLB
A|A4||8EC|2.0 TDI quattro Diesel|140/103|11/04 - 06/08|1968|D|01/06 - 06/08|BPW
A|A4||8EC|2.0 TDI quattro Diesel|163/120|11/04 - 06/08|1968|D|06/06 - 06/08|BVA
A|A4||8EC|2.0 TDI quattro Diesel|170/125|11/04 - 06/08|1968|D|06/06 - 06/08|BRD
A|A4||8EC|2.0 TFSI Petrol|170/125|11/04 - 06/08|1984|P|10/06 - 06/08|BPJ
A|A4||8EC|2.0 TFSI Petrol|200/147|11/04 - 06/08|1984|P|11/04 - 06/08|BGB
A|A4||8EC|2.0 TFSI Petrol|203/149|11/04 - 06/08|1984|P|09/06 - 06/08|BWT
A|A4||8EC|2.0 TFSI Petrol|220/162|11/04 - 06/08|1984|P|06/05 - 06/08|BUL
A|A4||8EC|2.0 TFSI quattro Petrol|200/147|11/04 - 06/08|1984|P|11/04 - 06/08|BGB
A|A4||8EC|2.0 TFSI quattro Petrol|220/162|11/04 - 06/08|1984|P|06/05 - 06/08|BUL
A|A4||8EC|2.5 TDI Diesel|163/120|11/04 - 06/08|2496|D|11/04 - 05/06|BDG
A|A4||8EC|2.7 TDI Diesel|163/120|11/04 - 06/08|2698|D|11/05 - 06/08|BSG
A|A4||8EC|2.7 TDI Diesel|180/132|11/04 - 06/08|2698|D|01/06 - 06/08|BPP
A|A4||8EC|3.0 Petrol|218/160|11/04 - 06/08|2976|P|11/04 - 05/06|BBJ
A|A4||8EC|3.0 quattro Petrol|218/160|11/04 - 06/08|2976|P|11/04 - 07/06|BBJ
A|A4||8EC|3.0 TDI quattro Diesel|204/150|11/04 - 06/08|2967|D|11/04 - 06/08|BKN
A|A4||8EC|3.0 TDI quattro Diesel|233/171|11/04 - 06/08|2967|D|01/06 - 06/08|ASB
A|A4||8EC|3.2 FSI Petrol|255/188|11/04 - 06/08|3123|P|01/05 - 06/08|AUK
A|A4||8EC|3.2 FSI Petrol|258/190|11/04 - 06/08|3123|P|01/06 - 06/08|BKH
A|A4||8EC|3.2 FSI quattro Petrol|255/188|11/04 - 06/08|3123|P|01/05 - 06/08|AUK
A|RS4||8EC|4.2 FSI quattro Petrol|420/309|11/04 - 06/08|4163|P|09/05 - 06/08|BNS
A|S4||8EC|4.2 quattro Petrol|344/253|11/04 - 06/08|4163|P|11/04 - 06/08|BBK
A|A4 Avant||8ED|1.6 Petrol|102/75|11/04 - 06/08|1595|P|11/04 - 06/08|ALZ
A|A4 Avant||8ED|1.8 T Petrol|163/120|11/04 - 06/08|1781|P|11/04 - 06/08|BFB
A|A4 Avant||8ED|1.8 T quattro Petrol|163/120|11/04 - 06/08|1781|P|11/04 - 06/08|BFB
A|A4 Avant||8ED|1.9 TDI Diesel|116/85|11/04 - 06/08|1896|D|11/04 - 06/08|BKE
A|A4 Avant||8ED|2.0 Petrol|130/96|11/04 - 06/08|1984|P|11/04 - 06/08|ALT
A|A4 Avant||8ED|2.0 TDI Diesel|121/89|11/04 - 06/08|1968|D|09/05 - 09/06|BVG
A|A4 Avant||8ED|2.0 TDI Diesel|126/93|11/04 - 06/08|1968|D|11/05 - 11/06|BVF
A|A4 Avant||8ED|2.0 TDI Diesel|136/100|11/04 - 06/08|1968|D|11/04 - 06/08|BNA
A|A4 Avant||8ED|2.0 TDI Diesel|140/103|11/04 - 06/08|1968|D|11/04 - 06/08|BPW
A|A4 Avant||8ED|2.0 TDI Diesel|163/120|11/04 - 06/08|1968|D|06/06 - 06/08|BVA
A|A4 Avant||8ED|2.0 TDI Diesel|170/125|11/04 - 06/08|1968|D|06/06 - 06/08|BRD
A|A4 Avant||8ED|2.0 TDI 16V Diesel|140/103|11/04 - 06/08|1968|D|11/04 - 06/08|BLB
A|A4 Avant||8ED|2.0 TDI quattro Diesel|140/103|11/04 - 06/08|1968|D|01/06 - 06/08|BPW
A|A4 Avant||8ED|2.0 TDI quattro Diesel|163/120|11/04 - 06/08|1968|D|06/06 - 06/08|BVA
A|A4 Avant||8ED|2.0 TDI quattro Diesel|170/125|11/04 - 06/08|1968|D|06/06 - 06/08|BRD
A|A4 Avant||8ED|2.0 TFSI Petrol|170/125|11/04 - 06/08|1984|P|10/06 - 06/08|BPJ
A|A4 Avant||8ED|2.0 TFSI Petrol|200/147|11/04 - 06/08|1984|P|11/04 - 06/08|BGB
A|A4 Avant||8ED|2.0 TFSI Petrol|220/162|11/04 - 06/08|1984|P|06/05 - 06/08|BUL
A|A4 Avant||8ED|2.0 TFSI quattro Petrol|200/147|11/04 - 06/08|1984|P|11/04 - 06/08|BGB
A|A4 Avant||8ED|2.0 TFSI quattro Petrol|220/162|11/04 - 06/08|1984|P|06/05 - 06/08|BUL
A|A4 Avant||8ED|2.5 TDI Diesel|163/120|11/04 - 06/08|2496|D|11/04 - 05/06|BDG
A|A4 Avant||8ED|2.7 TDI Diesel|163/120|11/04 - 06/08|2698|D|11/05 - 03/08|BSG
A|A4 Avant||8ED|2.7 TDI Diesel|180/132|11/04 - 06/08|2698|D|01/06 - 06/08|BPP
A|A4 Avant||8ED|3.0 Petrol|218/160|11/04 - 06/08|2976|P|11/04 - 05/06|BBJ
A|A4 Avant||8ED|3.0 quattro Petrol|218/160|11/04 - 06/08|2976|P|11/04 - 07/06|BBJ
A|A4 Avant||8ED|3.0 TDI quattro Diesel|204/150|11/04 - 06/08|2967|D|11/04 - 06/08|BKN
A|A4 Avant||8ED|3.0 TDI quattro Diesel|233/171|11/04 - 06/08|2967|D|01/06 - 06/08|ASB
A|A4 Avant||8ED|3.2 FSI Petrol|255/188|11/04 - 06/08|3123|P|01/05 - 06/08|AUK
A|A4 Avant||8ED|3.2 FSI quattro Petrol|255/188|11/04 - 06/08|3123|P|01/05 - 06/08|AUK
A|RS4 Avant||8ED|4.2 FSI quattro Petrol|420/309|11/04 - 06/08|4163|P|09/05 - 06/08|BNS
A|S4 Avant||8ED|4.2 quattro Petrol|344/253|11/04 - 06/08|4163|P|11/04 - 06/08|BBK
A|A4 Convertible||8HE|1.8 T Petrol|163/120|01/02 - 12/09|1781|P|01/06 - 03/09|BFB
A|A4 Convertible||8HE|2.0 TDI Diesel|136/100|01/02 - 12/09|1968|D|01/06 - 03/09|BRC
A|A4 Convertible||8HE|2.0 TDI Diesel|140/103|01/02 - 12/09|1968|D|01/06 - 03/09|BPW
A|A4 Convertible||8HE|2.0 TFSI 16V Petrol|200/147|01/02 - 12/09|1984|P|01/06 - 03/09|BWE
A|A4 Convertible||8HE|2.0 TFSI quattro Petrol|200/147|01/02 - 12/09|1984|P|11/05 - 03/09|BWT
A|A4 Convertible||8HE|2.7 TDI Diesel|180/132|01/02 - 12/09|2698|D|05/06 - 03/09|BPP
A|A4 Convertible||8HE|3.0 TDI quattro Diesel|204/150|01/02 - 12/09|2967|D|01/06 - 03/09|BKN
A|A4 Convertible||8HE|3.0 TDI quattro Diesel|233/171|01/02 - 12/09|2967|D|01/06 - 03/09|ASB
A|A4 Convertible||8HE|3.2 FSI Petrol|255/188|01/02 - 12/09|3123|P|01/06 - 03/09|AUK
A|A4 Convertible||8HE|3.2 FSI quattro Petrol|255/188|01/02 - 12/09|3123|P|01/06 - 03/09|AUK
A|RS4 Convertible||8HE|4.2 FSI quattro Petrol|420/309|01/02 - 12/09|4163|P|02/06 - 12/08|BNS
A|S4 Convertible||8HE|4.2 quattro Petrol|344/253|01/02 - 12/09|4163|P|11/05 - 03/09|BBK
A|A4||8K2|1.8 TFSI Petrol|120/88|11/07 - 12/15|1798|P|01/08 - 12/15|CABA
A|A4||8K2|1.8 TFSI Petrol|160/118|11/07 - 12/15|1798|P|11/07 - 03/12|CABB
A|A4||8K2|1.8 TFSI Petrol|170/125|11/07 - 12/15|1798|P|11/11 - 12/15|CJEB
A|A4||8K2|1.8 TFSI quattro Petrol|160/118|11/07 - 12/15|1798|P|09/08 - 03/12|CDHB
A|A4||8K2|1.8 TFSI quattro Petrol|170/125|11/07 - 12/15|1798|P|11/11 - 12/15|CJEB
A|A4||8K2|2.0 TDI Diesel|120/88|11/07 - 12/15|1968|D|06/08 - 12/15|CAGC
A|A4||8K2|2.0 TDI Diesel|136/100|11/07 - 12/15|1968|D|11/07 - 12/15|CAGB
A|A4||8K2|2.0 TDI Diesel|143/105|11/07 - 12/15|1968|D|11/07 - 12/15|CAGA
A|A4||8K2|2.0 TDI Diesel|150/110|11/07 - 12/15|1968|D|05/13 - 12/15|CJCD
A|A4||8K2|2.0 TDI Diesel|163/120|11/07 - 12/15|1968|D|08/08 - 12/15|CAHB
A|A4||8K2|2.0 TDI Diesel|170/125|11/07 - 12/15|1968|D|01/08 - 03/12|CAHA
A|A4||8K2|2.0 TDI Diesel|177/130|11/07 - 12/15|1968|D|11/11 - 12/15|CGLC
A|A4||8K2|2.0 TDI Diesel|190/140|11/07 - 12/15|1968|D|09/13 - 12/15|CNHA
A|A4||8K2|2.0 TDI quattro Diesel|143/105|11/07 - 12/15|1968|D|11/08 - 12/15|CAGA
A|A4||8K2|2.0 TDI quattro Diesel|150/110|11/07 - 12/15|1968|D|05/13 - 12/15|CJCD
A|A4||8K2|2.0 TDI quattro Diesel|170/125|11/07 - 12/15|1968|D|01/08 - 03/12|CAHA
A|A4||8K2|2.0 TDI quattro Diesel|177/130|11/07 - 12/15|1968|D|11/11 - 12/15|CGLC
A|A4||8K2|2.0 TDI quattro Diesel|190/140|11/07 - 12/15|1968|D|09/13 - 12/15|CNHA
A|A4||8K2|2.0 TFSI Petrol|180/132|11/07 - 12/15|1984|P|06/08 - 12/15|CAEA
A|A4||8K2|2.0 TFSI Petrol|211/155|11/07 - 12/15|1984|P|06/08 - 05/13|CAEB
A|A4||8K2|2.0 TFSI Petrol|220/162|11/07 - 12/15|1984|P|05/13 - 12/15|CAED
A|A4||8K2|2.0 TFSI Petrol|224/165|11/07 - 12/15|1984|P|05/13 - 12/15|CNCD
A|A4||8K2|2.0 TFSI Flexfuel quattro Petrol/Ethanol|211/155|11/07 - 12/15|1984|PT|09/12 - 12/13|CPMA
A|A4||8K2|2.0 TFSI Flexfuel quattro Petrol/Ethanol|220/162|11/07 - 12/15|1984|PT|05/13 - 12/15|CPMB
A|A4||8K2|2.0 TFSI flexible fuel Petrol/Ethanol|180/132|11/07 - 12/15|1984|PT|11/09 - 12/15|CFKA
A|A4||8K2|2.0 TFSI flexible fuel quattro Petrol/Ethanol|180/132|11/07 - 12/15|1984|PT|11/09 - 12/15|CFKA
A|A4||8K2|2.0 TFSI quattro Petrol|180/132|11/07 - 12/15|1984|P|11/09 - 03/12|CFKA
A|A4||8K2|2.0 TFSI quattro Petrol|211/155|11/07 - 12/15|1984|P|06/08 - 12/15|CAEB
A|A4||8K2|2.0 TFSI quattro Petrol|220/162|11/07 - 12/15|1984|P|05/13 - 12/15|CAED
A|A4||8K2|2.0 TFSI quattro Petrol|224/165|11/07 - 12/15|1984|P|05/13 - 12/15|CNCD
A|A4||8K2|2.7 TDI Diesel|163/120|11/07 - 12/15|2698|D|11/07 - 03/12|CAMB
A|A4||8K2|2.7 TDI Diesel|190/140|11/07 - 12/15|2698|D|11/07 - 03/12|CAMA
A|A4||8K2|3.0 TDI Diesel|204/150|11/07 - 12/15|2967|D|11/11 - 12/15|CLAB
A|A4||8K2|3.0 TDI quattro Diesel|211/155|11/07 - 12/15|2967|D|06/08 - 05/10|CCWB
A|A4||8K2|3.0 TDI quattro Diesel|240/176|11/07 - 12/15|2967|D|11/07 - 03/12|CAPA
A|A4||8K2|3.0 TDI quattro Diesel|245/180|11/07 - 12/15|2967|D|11/11 - 12/15|CDUC
A|A4||8K2|3.0 TFSI quattro Petrol|272/200|11/07 - 12/15|2995|P|02/12 - 12/15|CMUA
A|A4||8K2|3.2 FSI Petrol|265/195|11/07 - 12/15|3197|P|09/08 - 03/12|CALA
A|A4||8K2|3.2 FSI quattro Petrol|265/195|11/07 - 12/15|3197|P|11/07 - 03/12|CALA
A|S4||8K2|3.0 TFSI quattro Petrol|333/245|11/07 - 12/15|2995|P|11/08 - 12/15|CAKA
A|A4 Avant||8K5|1.8 TFSI Petrol|120/88|11/07 - 12/15|1798|P|04/08 - 12/15|CDHA
A|A4 Avant||8K5|1.8 TFSI Petrol|160/118|11/07 - 12/15|1798|P|11/07 - 03/12|CABB
A|A4 Avant||8K5|1.8 TFSI Petrol|170/125|11/07 - 12/15|1798|P|11/11 - 12/15|CJEB
A|A4 Avant||8K5|1.8 TFSI quattro Petrol|160/118|11/07 - 12/15|1798|P|09/08 - 03/12|CDHB
A|A4 Avant||8K5|1.8 TFSI quattro Petrol|170/125|11/07 - 12/15|1798|P|11/11 - 12/15|CJEB
A|A4 Avant||8K5|2.0 TDI Diesel|120/88|11/07 - 12/15|1968|D|06/08 - 12/15|CAGC
A|A4 Avant||8K5|2.0 TDI Diesel|136/100|11/07 - 12/15|1968|D|04/08 - 12/15|CAGB
A|A4 Avant||8K5|2.0 TDI Diesel|143/105|11/07 - 12/15|1968|D|04/08 - 12/15|CAGA
A|A4 Avant||8K5|2.0 TDI Diesel|150/110|11/07 - 12/15|1968|D|05/13 - 12/15|CJCD
A|A4 Avant||8K5|2.0 TDI Diesel|163/120|11/07 - 12/15|1968|D|08/08 - 12/15|CAHB
A|A4 Avant||8K5|2.0 TDI Diesel|170/125|11/07 - 12/15|1968|D|04/08 - 03/12|CAHA
A|A4 Avant||8K5|2.0 TDI Diesel|177/130|11/07 - 12/15|1968|D|11/11 - 12/15|CGLC
A|A4 Avant||8K5|2.0 TDI Diesel|190/140|11/07 - 12/15|1968|D|09/13 - 12/15|CNHA
A|A4 Avant||8K5|2.0 TDI quattro Diesel|143/105|11/07 - 12/15|1968|D|04/08 - 12/15|CAGA
A|A4 Avant||8K5|2.0 TDI quattro Diesel|150/110|11/07 - 12/15|1968|D|05/13 - 12/15|CJCD
A|A4 Avant||8K5|2.0 TDI quattro Diesel|170/125|11/07 - 12/15|1968|D|08/08 - 03/12|CAHA
A|A4 Avant||8K5|2.0 TDI quattro Diesel|177/130|11/07 - 12/15|1968|D|11/11 - 12/15|CGLC
A|A4 Avant||8K5|2.0 TDI quattro Diesel|190/140|11/07 - 12/15|1968|D|09/13 - 12/15|CNHA
A|A4 Avant||8K5|2.0 TFSI Petrol|180/132|11/07 - 12/15|1984|P|06/08 - 12/15|CDNB
A|A4 Avant||8K5|2.0 TFSI Petrol|211/155|11/07 - 12/15|1984|P|06/08 - 05/13|CAEB
A|A4 Avant||8K5|2.0 TFSI Petrol|224/165|11/07 - 12/15|1984|P|05/13 - 12/15|CNCD
A|A4 Avant||8K5|2.0 TFSI flexible fuel Petrol/Ethanol|180/132|11/07 - 12/15|1984|PT|11/09 - 12/15|CFKA
A|A4 Avant||8K5|2.0 TFSI flexible fuel quattro Petrol/Ethanol|180/132|11/07 - 12/15|1984|PT|11/09 - 12/15|CFKA
A|A4 Avant||8K5|2.0 TFSI quattro Petrol|211/155|11/07 - 12/15|1984|P|06/08 - 12/15|CAEB
A|A4 Avant||8K5|2.0 TFSI quattro Petrol|224/165|11/07 - 12/15|1984|P|05/13 - 12/15|CNCD
A|A4 Avant||8K5|2.7 TDI Diesel|163/120|11/07 - 12/15|2698|D|04/08 - 03/12|CAMB
A|A4 Avant||8K5|2.7 TDI Diesel|190/140|11/07 - 12/15|2698|D|04/08 - 03/12|CAMA
A|A4 Avant||8K5|3.0 TDI Diesel|204/150|11/07 - 12/15|2967|D|11/11 - 12/15|CLAB
A|A4 Avant||8K5|3.0 TDI quattro Diesel|211/155|11/07 - 12/15|2967|D|06/08 - 05/10|CCWB
A|A4 Avant||8K5|3.0 TDI quattro Diesel|240/176|11/07 - 12/15|2967|D|04/08 - 03/12|CAPA
A|A4 Avant||8K5|3.0 TDI quattro Diesel|245/180|11/07 - 12/15|2967|D|11/11 - 12/15|CDUC
A|A4 Avant||8K5|3.0 TFSI quattro Petrol|272/200|11/07 - 12/15|2995|P|02/12 - 12/15|CMUA
A|A4 Avant||8K5|3.2 FSI Petrol|265/195|11/07 - 12/15|3197|P|09/08 - 03/12|CALA
A|A4 Avant||8K5|3.2 FSI quattro Petrol|265/195|11/07 - 12/15|3197|P|04/08 - 03/12|CALA
A|RS4 Avant||8K5|4.2 FSI quattro Petrol|450/331|11/07 - 12/15|4163|P|05/12 - 08/15|CFSA
A|S4 Avant||8K5|3.0 TFSI quattro Petrol|333/245|11/07 - 12/15|2995|P|11/08 - 12/15|CAKA
A|A4||8W2 / 8WC|1.4 TFSI Petrol|150/110|05/15 -|1395|P|08/15 - 11/19|CVNA
A|A4||8W2 / 8WC|2.0 TDI Diesel|122/90|05/15 -|1968|D|05/16 - 11/19|DEUC
A|A4||8W2 / 8WC|2.0 TDI Diesel|136/100|05/15 -|1968|D|05/15 - 11/19|DEUB
A|A4||8W2 / 8WC|2.0 TDI Diesel|150/110|05/15 -|1968|D|05/15 - 11/19|CZHA
A|A4||8W2 / 8WC|2.0 TDI Diesel|190/140|05/15 -|1968|D|05/15 - 11/19|DESA
A|A4||8W2 / 8WC|2.0 TDI quattro Diesel|150/110|05/15 -|1968|D|09/16 - 11/19|DEUA
A|A4||8W2 / 8WC|2.0 TDI quattro Diesel|163/120|05/15 -|1968|D|09/16 - 11/19|DETB
A|A4||8W2 / 8WC|2.0 TDI quattro Diesel|190/140|05/15 -|1968|D|09/15 - 11/19|DESA
A|A4||8W2 / 8WC|2.0 TFSI Petrol|190/140|05/15 -|1984|P|05/15 - 11/19|CVKB
A|A4||8W2 / 8WC|2.0 TFSI Petrol|249/183|05/15 -|1984|P|11/15 - 11/19|CYRC
A|A4||8W2 / 8WC|2.0 TFSI Petrol|252/185|05/15 -|1984|P|05/15 - 11/19|CYMC
A|A4||8W2 / 8WC|2.0 TFSI Mild Hybrid Petrol/Electric|252/185|05/15 -|1984|PE|05/17 - 11/19|DDWA
A|A4||8W2 / 8WC|2.0 TFSI Mild Hybrid quattro Petrol/Electric|252/185|05/15 -|1984|PE|05/17 - 11/19|DDWA
A|A4||8W2 / 8WC|2.0 TFSI quattro Petrol|249/183|05/15 -|1984|P|11/15 - 11/19|CYRC
A|A4||8W2 / 8WC|2.0 TFSI quattro Petrol|252/185|05/15 -|1984|P|05/15 - 11/19|CYMC
A|A4||8W2 / 8WC|3.0 TDI Diesel|218/160|05/15 -|2967|D|09/15 - 08/18|CSWB
A|A4||8W2 / 8WC|3.0 TDI quattro Diesel|218/160|05/15 -|2967|D|09/15 - 08/18|CSWB
A|A4||8W2 / 8WC|3.0 TDI quattro Diesel|272/200|05/15 -|2967|D|05/15 - 08/18|CRTC
A|A4||8W2 / 8WC|30 TDI Diesel|122/90|05/15 -|1968|D|05/16 - 11/19|DEUC
A|A4||8W2 / 8WC|30 TDI Mild Hybrid Diesel/Electric|136/100|05/15 -|1968|DE|07/19 -|DEZB
A|A4||8W2 / 8WC|35 TDI Diesel|150/110|05/15 -|1968|D|08/15 -|CZHA
A|A4||8W2 / 8WC|35 TDI Mild Hybrid Diesel/Electric|163/120|05/15 -|1968|DE|03/19 -|DEZE
A|A4||8W2 / 8WC|35 TFSI Mild Hybrid Petrol/Electric|150/110|05/15 -|1984|PE|12/18 -|CVKC
A|A4||8W2 / 8WC|40 TDI Diesel|190/140|05/15 -|1968|D|05/15 -|DESA
A|A4||8W2 / 8WC|40 TDI Mild Hybrid Diesel/Electric|204/150|05/15 -|1968|DE|09/20 -|DTPA
A|A4||8W2 / 8WC|40 TDI Mild Hybrid quattro Diesel/Electric|204/150|05/15 -|1968|DE|05/20 -|DTPA
A|A4||8W2 / 8WC|40 TDI quattro Diesel|190/140|05/15 -|1968|D|09/15 - 09/20|DETA
A|A4||8W2 / 8WC|40 TFSI Mild Hybrid Petrol/Electric|190/140|05/15 -|1984|PE|05/17 -|DEMA
A|A4||8W2 / 8WC|40 TFSI Mild Hybrid Petrol/Electric|204/150|05/15 -|1984|PE|06/20 -|DMSA
A|A4||8W2 / 8WC|40 TFSI Mild Hybrid quattro Petrol/Electric|204/150|05/15 -|1984|PE|06/20 -|DMSA
A|A4||8W2 / 8WC|45 TDI quattro Diesel|231/170|05/15 -|2967|D|07/18 -|DCPE
A|A4||8W2 / 8WC|45 TFSI Mild Hybrid Petrol/Electric|245/180|05/15 -|1984|PE|07/18 - 11/19|DKNA
A|A4||8W2 / 8WC|45 TFSI Mild Hybrid quattro Petrol/Electric|245/180|05/15 -|1984|PE|07/18 - 08/20|DKNA
A|A4||8W2 / 8WC|45 TFSI Mild Hybrid quattro Petrol/Electric|249/183|05/15 -|1984|PE|02/20 -|DDWA
A|A4||8W2 / 8WC|45 TFSI Mild Hybrid quattro Petrol/Electric|265/195|05/15 -|1984|PE|08/20 -|DMTA
A|A4||8W2 / 8WC|50 TDI Mild Hybrid quattro Diesel/Electric|286/210|05/15 -|2967|DE|08/20 -|DMGA
A|A4||8W2 / 8WC|50 TDI quattro Diesel|286/210|05/15 -|2967|D|07/18 - 08/20|DCPC
A|S4||8W2 / 8WC|3.0 TDI Mild Hybrid quattro Diesel/Electric|341/251|05/15 -|2967|DE|01/21 - 03/23|DMKC
A|S4||8W2 / 8WC|3.0 TDI Mild Hybrid quattro Diesel/Electric|347/255|05/15 -|2967|DE|05/19 -|DEWB
A|S4||8W2 / 8WC|3.0 TFSI quattro Petrol|354/260|05/15 -|2995|P|05/16 -|CWGD
A|A4 Avant||8W5 / 8WD|1.4 TFSI Petrol|150/110|08/15 -|1395|P|02/16 - 10/19|CVNA
A|A4 Avant||8W5 / 8WD|2.0 TDI Diesel|122/90|08/15 -|1968|D|04/16 - 09/18|DEUC
A|A4 Avant||8W5 / 8WD|2.0 TDI Diesel|136/100|08/15 -|1968|D|08/15 - 10/19|DEUB
A|A4 Avant||8W5 / 8WD|2.0 TDI Diesel|150/110|08/15 -|1968|D|08/15 - 09/18|CZHA
A|A4 Avant||8W5 / 8WD|2.0 TDI Diesel|190/140|08/15 -|1968|D|08/15 - 09/18|DESA
A|A4 Avant||8W5 / 8WD|2.0 TDI quattro Diesel|150/110|08/15 -|1968|D|09/16 - 10/19|DEUA
A|A4 Avant||8W5 / 8WD|2.0 TDI quattro Diesel|163/120|08/15 -|1968|D|09/16 - 09/18|DETB
A|A4 Avant||8W5 / 8WD|2.0 TDI quattro Diesel|190/140|08/15 -|1968|D|10/15 - 09/18|DESA
A|A4 Avant||8W5 / 8WD|2.0 TFSI Petrol|190/140|08/15 -|1984|P|08/15 -|CVKB
A|A4 Avant||8W5 / 8WD|2.0 TFSI Petrol|249/183|08/15 -|1984|P|05/16 - 10/19|CYRC
A|A4 Avant||8W5 / 8WD|2.0 TFSI Petrol|252/185|08/15 -|1984|P|05/16 - 10/19|CYMC
A|A4 Avant||8W5 / 8WD|2.0 TFSI g-tron Petrol/CNG|170/125|08/15 -|1984|PC|11/16 - 10/19|CVLA
A|A4 Avant||8W5 / 8WD|2.0 TFSI Mild Hybrid Petrol/Electric|252/185|08/15 -|1984|PE|05/17 - 10/19|DDWA
A|A4 Avant||8W5 / 8WD|2.0 TFSI Mild Hybrid quattro Petrol/Electric|252/185|08/15 -|1984|PE|05/17 - 06/18|DDWA
A|A4 Avant||8W5 / 8WD|2.0 TFSI quattro Petrol|249/183|08/15 -|1984|P|11/15 - 10/19|CYRC
A|A4 Avant||8W5 / 8WD|2.0 TFSI quattro Petrol|252/185|08/15 -|1984|P|08/15 - 10/19|CYMC
A|A4 Avant||8W5 / 8WD|3.0 TDI Diesel|218/160|08/15 -|2967|D|10/15 - 08/18|CSWB
A|A4 Avant||8W5 / 8WD|3.0 TDI quattro Diesel|218/160|08/15 -|2967|D|11/15 - 08/18|CSWB
A|A4 Avant||8W5 / 8WD|3.0 TDI quattro Diesel|272/200|08/15 -|2967|D|08/15 - 08/18|CRTC
A|A4 Avant||8W5 / 8WD|30 TDI Diesel|122/90|08/15 -|1968|D|10/18 - 10/20|DEUC
A|A4 Avant||8W5 / 8WD|30 TDI Mild Hybrid Diesel/Electric|136/100|08/15 -|1968|DE|07/19 -|DEZB
A|A4 Avant||8W5 / 8WD|35 TDI Diesel|150/110|08/15 -|1968|D|10/18 - 10/19|DEUA
A|A4 Avant||8W5 / 8WD|35 TDI Mild Hybrid Diesel/Electric|163/120|08/15 -|1968|DE|07/19 -|DEZE
A|A4 Avant||8W5 / 8WD|35 TFSI Mild Hybrid Petrol/Electric|150/110|08/15 -|1984|PE|12/18 -|CVKC
A|A4 Avant||8W5 / 8WD|40 TDI Diesel|190/140|08/15 -|1968|D|10/18 - 08/20|DESA
A|A4 Avant||8W5 / 8WD|40 TDI Mild Hybrid Diesel/Electric|204/150|08/15 -|1968|DE|09/20 -|DTPA
A|A4 Avant||8W5 / 8WD|40 TDI Mild Hybrid quattro Diesel/Electric|204/150|08/15 -|1968|DE|05/20 -|DTPA
A|A4 Avant||8W5 / 8WD|40 TDI quattro Diesel|190/140|08/15 -|1968|D|10/18 - 09/20|DETA
A|A4 Avant||8W5 / 8WD|40 TFSI Petrol|204/150|08/15 -|1984|P|12/20 -|DMSA
A|A4 Avant||8W5 / 8WD|40 TFSI g-tron Petrol/CNG|170/125|08/15 -|1984|PC|11/16 -|CVLA
A|A4 Avant||8W5 / 8WD|40 TFSI Mild Hybrid Petrol/Electric|190/140|08/15 -|1984|PE|05/17 -|DEMA
A|A4 Avant||8W5 / 8WD|40 TFSI Mild Hybrid Petrol/Electric|204/150|08/15 -|1984|PE|06/20 -|DMSA
A|A4 Avant||8W5 / 8WD|40 TFSI Mild Hybrid quattro Petrol/Electric|204/150|08/15 -|1984|PE|06/20 -|DMSA
A|A4 Avant||8W5 / 8WD|45 TDI quattro Diesel|231/170|08/15 -|2967|D|07/18 -|DCPE
A|A4 Avant||8W5 / 8WD|45 TFSI Mild Hybrid Petrol/Electric|245/180|08/15 -|1984|PE|07/18 - 10/19|DKNA
A|A4 Avant||8W5 / 8WD|45 TFSI Mild Hybrid quattro Petrol/Electric|245/180|08/15 -|1984|PE|07/18 - 08/20|DKNA
A|A4 Avant||8W5 / 8WD|45 TFSI Mild Hybrid quattro Petrol/Electric|249/183|08/15 -|1984|PE|02/20 -|DDWA
A|A4 Avant||8W5 / 8WD|45 TFSI Mild Hybrid quattro Petrol/Electric|265/195|08/15 -|1984|PE|08/20 -|DMTA
A|A4 Avant||8W5 / 8WD|50 TDI Mild Hybrid quattro Diesel/Electric|286/210|08/15 -|2967|DE|08/20 -|DMGA
A|A4 Avant||8W5 / 8WD|50 TDI quattro Diesel|286/210|08/15 -|2967|D|07/18 - 10/19|DCPC
A|RS4 Avant||8W5 / 8WD|2.9 TFSI quattro Petrol|450/331|08/15 -|2894|P|10/17 -|DECA
A|RS4 Avant||8W5 / 8WD|2.9 TFSI quattro Petrol|471/346|08/15 -|2894|P|07/24 - 12/24|DECC
A|S4 Avant||8W5 / 8WD|3.0 TDI Mild Hybrid quattro Diesel/Electric|341/251|08/15 -|2967|DE|01/21 -|DMKC
A|S4 Avant||8W5 / 8WD|3.0 TDI Mild Hybrid quattro Diesel/Electric|347/255|08/15 -|2967|DE|05/19 -|DEWB
A|S4 Avant||8W5 / 8WD|3.0 TFSI quattro Petrol|354/260|08/15 -|2995|P|05/16 -|CWGD
A|A7 Sportback|S|4GA / 4GF|1.8 35 TFSI Petrol|190/140|10/10 - 05/18|1798|P|02/16 - 05/18|CYGA
A|A7 Sportback|S|4GA / 4GF|1.8 TFSI Petrol|190/140|10/10 - 05/18|1798|P|04/15 - 05/18|CYGA
A|A7 Sportback|S|4GA / 4GF|2.0 40 TFSI Petrol|252/185|10/10 - 05/18|1984|P|09/15 - 05/18|CYPA
A|A7 Sportback|S|4GA / 4GF|2.0 40 TFSI quattro Petrol|252/185|10/10 - 05/18|1984|P|09/15 - 05/18|CYPA
A|A7 Sportback|S|4GA / 4GF|2.0 TFSI Petrol|252/185|10/10 - 05/18|1984|P|09/14 - 05/18|CYPA
A|A7 Sportback|S|4GA / 4GF|2.0 TFSI quattro Petrol|249/183|10/10 - 05/18|1984|P|05/15 - 05/18|CYRB
A|A7 Sportback|S|4GA / 4GF|2.0 TFSI quattro Petrol|252/185|10/10 - 05/18|1984|P|05/15 - 05/18|CYNB
A|A7 Sportback|S|4GA / 4GF|2.5 FSI Petrol|204/150|10/10 - 05/18|2498|P|09/12 - 03/15|CLXB
A|A7 Sportback|S|4GA / 4GF|2.8 FSI Petrol|204/150|10/10 - 05/18|2773|P|02/11 - 03/15|CHVA
A|A7 Sportback|S|4GA / 4GF|2.8 FSI quattro Petrol|204/150|10/10 - 05/18|2773|P|10/10 - 03/15|CHVA
A|A7 Sportback|S|4GA / 4GF|2.8 FSI quattro Petrol|220/162|10/10 - 05/18|2773|P|09/14 - 05/18|CVPA
A|A7 Sportback|S|4GA / 4GF|3.0 50 TFSI quattro Petrol|333/245|10/10 - 05/18|2995|P|09/15 - 05/18|CREC
A|A7 Sportback|S|4GA / 4GF|3.0 TDI Diesel|190/140|10/10 - 05/18|2967|D|11/15 - 05/18|CZVE
A|A7 Sportback|S|4GA / 4GF|3.0 TDI Diesel|204/150|10/10 - 05/18|2967|D|11/10 - 03/15|CLAB
A|A7 Sportback|S|4GA / 4GF|3.0 TDI Diesel|211/155|10/10 - 05/18|2967|D|11/15 - 05/18|CTCB
A|A7 Sportback|S|4GA / 4GF|3.0 TDI Diesel|218/160|10/10 - 05/18|2967|D|07/14 - 05/18|CTCC
A|A7 Sportback|S|4GA / 4GF|3.0 TDI quattro Diesel|190/140|10/10 - 05/18|2967|D|11/15 - 05/18|CZVE
A|A7 Sportback|S|4GA / 4GF|3.0 TDI quattro Diesel|204/150|10/10 - 05/18|2967|D|12/10 - 03/15|CLAA
A|A7 Sportback|S|4GA / 4GF|3.0 TDI quattro Diesel|211/155|10/10 - 05/18|2967|D|07/14 - 05/18|CRTF
A|A7 Sportback|S|4GA / 4GF|3.0 TDI quattro Diesel|218/160|10/10 - 05/18|2967|D|07/14 - 05/18|CRTF
A|A7 Sportback|S|4GA / 4GF|3.0 TDI quattro Diesel|239/176|10/10 - 05/18|2967|D|05/13 - 06/17|CPNB
A|A7 Sportback|S|4GA / 4GF|3.0 TDI quattro Diesel|245/180|10/10 - 05/18|2967|D|10/10 - 06/16|CDUC
A|A7 Sportback|S|4GA / 4GF|3.0 TDI quattro Diesel|272/200|10/10 - 05/18|2967|D|05/14 - 05/18|CRTD
A|A7 Sportback|S|4GA / 4GF|3.0 TDI quattro Diesel|313/230|10/10 - 05/18|2967|D|11/11 - 03/15|CGQB
A|A7 Sportback|S|4GA / 4GF|3.0 TDI quattro Diesel|320/235|10/10 - 05/18|2967|D|05/14 - 05/18|CVUA
A|A7 Sportback|S|4GA / 4GF|3.0 TDI quattro Diesel|326/240|10/10 - 05/18|2967|D|09/14 - 05/18|CVUB
A|A7 Sportback|S|4GA / 4GF|3.0 TFSI quattro Petrol|300/220|10/10 - 05/18|2995|P|10/10 - 05/12|CGWB
A|A7 Sportback|S|4GA / 4GF|3.0 TFSI quattro Petrol|310/228|10/10 - 05/18|2995|P|01/11 - 03/15|CGWD
A|A7 Sportback|S|4GA / 4GF|3.0 TFSI quattro Petrol|333/245|10/10 - 05/18|2995|P|05/14 - 05/18|CREC
A|A7 Sportback|S|4GA / 4GF|3.0 TFSI quattro Petrol|340/250|10/10 - 05/18|2995|P|05/16 - 05/18|CREH
A|RS7 Sportback|S|4GA / 4GF|4.0 TFSI performance quattro Petrol|605/445|10/10 - 05/18|3993|P|11/15 - 04/18|CWUC
A|RS7 Sportback|S|4GA / 4GF|4.0 TFSI quattro Petrol|560/412|10/10 - 05/18|3993|P|10/13 - 04/18|CRDB
A|S7 Sportback|S|4GA / 4GF|4.0 TFSI quattro Petrol|420/309|10/10 - 05/18|3993|P|02/12 - 03/15|CEUC
A|S7 Sportback|S|4GA / 4GF|4.0 TFSI quattro Petrol|450/331|10/10 - 05/18|3993|P|07/14 - 05/18|CTGE
A|A7 Sportback|S|4KA|35 TDI Mild Hybrid Diesel/Electric|163/120|10/17 -|1968|DE|10/20 -|DTPB
A|A7 Sportback|S|4KA|40 TDI Mild Hybrid Diesel/Electric|204/150|10/17 -|1968|DE|09/18 -|DFBA
A|A7 Sportback|S|4KA|40 TDI Mild Hybrid quattro Diesel/Electric|204/150|10/17 -|1968|DE|09/18 -|DFBA
A|A7 Sportback|S|4KA|40 TFSI Petrol|204/150|10/17 -|1984|P|11/22 -|DMTC
A|A7 Sportback|S|4KA|40 TFSI 12V Petrol|190/140|10/17 -|1984|P|11/19 -|DKYA
A|A7 Sportback|S|4KA|40 TFSI Mild Hybrid Petrol/Electric|190/140|10/17 -|1984|PE|08/20 -|DLHC
A|A7 Sportback|S|4KA|40 TFSI Mild Hybrid Petrol/Electric|204/150|10/17 -|1984|PE|08/20 -|DMTC
A|A7 Sportback|S|4KA|45 TDI Mild Hybrid quattro Diesel/Electric|211/155|10/17 -|2967|DE|04/18 -|DDVF
A|A7 Sportback|S|4KA|45 TDI Mild Hybrid quattro Diesel/Electric|231/170|10/17 -|2967|DE|06/18 -|DDVE
A|A7 Sportback|S|4KA|45 TDI Mild Hybrid quattro Diesel/Electric|245/180|10/17 -|2967|DE|01/21 -|DMGH
A|A7 Sportback|S|4KA|45 TDI quattro Diesel|249/183|10/17 -|2967|D|09/19 -|CVMD
A|A7 Sportback|S|4KA|45 TFSI Petrol|245/180|10/17 -|1984|P|11/19 -|DLHA
A|A7 Sportback|S|4KA|45 TFSI Petrol|265/195|10/17 -|1984|P|11/22 -|DMTA
A|A7 Sportback|S|4KA|45 TFSI Mild Hybrid Petrol/Electric|245/180|10/17 -|1984|PE|07/18 -|DKNA
A|A7 Sportback|S|4KA|45 TFSI Mild Hybrid Petrol/Electric|265/195|10/17 -|1984|PE|05/20 -|DMTA
A|A7 Sportback|S|4KA|45 TFSI Mild Hybrid quattro Petrol/Electric|245/180|10/17 -|1984|PE|07/18 -|DKNA
A|A7 Sportback|S|4KA|45 TFSI Mild Hybrid quattro Petrol/Electric|265/195|10/17 -|1984|PE|05/20 -|DMTA
A|A7 Sportback|S|4KA|50 TDI Mild Hybrid quattro Diesel/Electric|286/210|10/17 -|2967|DE|10/17 -|DDVB
A|A7 Sportback|S|4KA|50 TFSI e quattro Petrol/Electric|299/220|10/17 -|1984|PE|11/19 -|DLGA,DRYA
A|A7 Sportback|S|4KA|55 TFSI e quattro Petrol/Electric|367/270|10/17 -|1984|PE|07/19 -|DLGA,DRYA
A|A7 Sportback|S|4KA|55 TFSI Mild Hybrid quattro Petrol/Electric|340/250|10/17 -|2995|PE|10/17 -|DLZA
A|RS7 Sportback|S|4KA|4.0 TFSI Mild Hybrid quattro Petrol/Electric|630/463|10/17 -|3996|PE|01/23 -|DYGA
A|RS7 Sportback|S|4KA|4.0 TFSI Mild Hybrid quattro Petrol/Electric|600/441|10/17 -|3996|PE|10/19 -|DJPB
A|S7 Sportback|S|4KA|3.0 TDI Mild Hybrid quattro Diesel/Electric|344/253|10/17 -|2967|DE|11/20 -|DMKD
A|S7 Sportback|S|4KA|3.0 TDI Mild Hybrid quattro Diesel/Electric|349/257|10/17 -|2967|DE|03/19 -|DEWA
A|S7 Sportback|S|4KA|2.9 TFSI Mild Hybrid quattro Petrol/Electric|450/331|10/17 -|2894|PE|01/20 -|DKMB
`.trim();

  window.FF_VEHICLES =
    DATA
      .split('\n')
      .map(function (line) {
        return line.trim();
      })
      .filter(function (line) {
        return line && line.indexOf('|') !== -1;
      })
      .map(function (line) {
        var p = line.split('|');

        var vehicle = {
          make: MAKES[p[0]] || p[0],
          model: p[1] || '',
          bodyStyle:
            STYLES[p[2]] !== undefined
              ? STYLES[p[2]]
              : p[2],
          chassis: p[3] || '',
          engine: p[4] || '',
          power: p[5] || '',
          year: p[6] || '',
          engineCapacity:
            p[7] === ''
              ? null
              : Number(p[7]),
          fuelType:
            FUELS[p[8]] || p[8],
          engineYear:
            p[9] ||
            p[6] ||
            '',
          engineCodes:
            p[10]
              ? p[10]
                  .split(',')
                  .filter(Boolean)
              : []
        };

        vehicle.productTag =
          makeProductTag(vehicle);

        return vehicle;
      });
})();